
/* **********************************************
     Begin prism-core.js
********************************************** */

/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if ('currentScript' in document && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if (typeof module !== 'undefined' && module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof global !== 'undefined') {
	global.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */


/* **********************************************
     Begin prism-markup.js
********************************************** */

Prism.languages.markup = {
	'comment': {
		pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
		greedy: true
	},
	'prolog': {
		pattern: /<\?[\s\S]+?\?>/,
		greedy: true
	},
	'doctype': {
		// https://www.w3.org/TR/xml/#NT-doctypedecl
		pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
		greedy: true,
		inside: {
			'internal-subset': {
				pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
				lookbehind: true,
				greedy: true,
				inside: null // see below
			},
			'string': {
				pattern: /"[^"]*"|'[^']*'/,
				greedy: true
			},
			'punctuation': /^<!|>$|[[\]]/,
			'doctype-tag': /^DOCTYPE/i,
			'name': /[^\s<>'"]+/
		}
	},
	'cdata': {
		pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
		greedy: true
	},
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
		greedy: true,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'special-attr': [],
			'attr-value': {
				pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
				inside: {
					'punctuation': [
						{
							pattern: /^=/,
							alias: 'attr-equals'
						},
						{
							pattern: /^(\s*)["']|["']$/,
							lookbehind: true
						}
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': [
		{
			pattern: /&[\da-z]{1,8};/i,
			alias: 'named-entity'
		},
		/&#x?[\da-f]{1,8};/i
	]
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	/**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */
	value: function addInlined(tagName, lang) {
		var includedCdataInside = {};
		includedCdataInside['language-' + lang] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: true,
			inside: Prism.languages[lang]
		};
		includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;

		var inside = {
			'included-cdata': {
				pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
				inside: includedCdataInside
			}
		};
		inside['language-' + lang] = {
			pattern: /[\s\S]+/,
			inside: Prism.languages[lang]
		};

		var def = {};
		def[tagName] = {
			pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
			lookbehind: true,
			greedy: true,
			inside: inside
		};

		Prism.languages.insertBefore('markup', 'cdata', def);
	}
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
	/**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */
	value: function (attrName, lang) {
		Prism.languages.markup.tag.inside['special-attr'].push({
			pattern: RegExp(
				/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
				'i'
			),
			lookbehind: true,
			inside: {
				'attr-name': /^[^\s=]+/,
				'attr-value': {
					pattern: /=[\s\S]+/,
					inside: {
						'value': {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: true,
							alias: [lang, 'language-' + lang],
							inside: Prism.languages[lang]
						},
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							/"|'/
						]
					}
				}
			}
		});
	}
});

Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;


/* **********************************************
     Begin prism-css.js
********************************************** */

(function (Prism) {

	var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;

	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
			inside: {
				'rule': /^@[\w-]+/,
				'selector-function-argument': {
					pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
					lookbehind: true,
					alias: 'selector'
				},
				'keyword': {
					pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
					lookbehind: true
				}
				// See rest below
			}
		},
		'url': {
			// https://drafts.csswg.org/css-values-3/#urls
			pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
			greedy: true,
			inside: {
				'function': /^url/i,
				'punctuation': /^\(|\)$/,
				'string': {
					pattern: RegExp('^' + string.source + '$'),
					alias: 'url'
				}
			}
		},
		'selector': {
			pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
			lookbehind: true
		},
		'string': {
			pattern: string,
			greedy: true
		},
		'property': {
			pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
			lookbehind: true
		},
		'important': /!important\b/i,
		'function': {
			pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
			lookbehind: true
		},
		'punctuation': /[(){};:,]/
	};

	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;

	var markup = Prism.languages.markup;
	if (markup) {
		markup.tag.addInlined('style', 'css');
		markup.tag.addAttribute('style', 'css');
	}

}(Prism));


/* **********************************************
     Begin prism-clike.js
********************************************** */

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};


/* **********************************************
     Begin prism-javascript.js
********************************************** */

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;


/* **********************************************
     Begin prism-file-highlight.js
********************************************** */

(function () {

	if (typeof Prism === 'undefined' || typeof document === 'undefined') {
		return;
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	var LOADING_MESSAGE = 'Loading…';
	var FAILURE_MESSAGE = function (status, message) {
		return '✖ Error ' + status + ' while fetching file: ' + message;
	};
	var FAILURE_EMPTY_MESSAGE = '✖ Error: File does not exist or is empty';

	var EXTENSIONS = {
		'js': 'javascript',
		'py': 'python',
		'rb': 'ruby',
		'ps1': 'powershell',
		'psm1': 'powershell',
		'sh': 'bash',
		'bat': 'batch',
		'h': 'c',
		'tex': 'latex'
	};

	var STATUS_ATTR = 'data-src-status';
	var STATUS_LOADING = 'loading';
	var STATUS_LOADED = 'loaded';
	var STATUS_FAILED = 'failed';

	var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])'
		+ ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';

	/**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */
	function loadFile(src, success, error) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', src, true);
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4) {
				if (xhr.status < 400 && xhr.responseText) {
					success(xhr.responseText);
				} else {
					if (xhr.status >= 400) {
						error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
					} else {
						error(FAILURE_EMPTY_MESSAGE);
					}
				}
			}
		};
		xhr.send(null);
	}

	/**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */
	function parseRange(range) {
		var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
		if (m) {
			var start = Number(m[1]);
			var comma = m[2];
			var end = m[3];

			if (!comma) {
				return [start, start];
			}
			if (!end) {
				return [start, undefined];
			}
			return [start, Number(end)];
		}
		return undefined;
	}

	Prism.hooks.add('before-highlightall', function (env) {
		env.selector += ', ' + SELECTOR;
	});

	Prism.hooks.add('before-sanity-check', function (env) {
		var pre = /** @type {HTMLPreElement} */ (env.element);
		if (pre.matches(SELECTOR)) {
			env.code = ''; // fast-path the whole thing and go to complete

			pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading

			// add code element with loading message
			var code = pre.appendChild(document.createElement('CODE'));
			code.textContent = LOADING_MESSAGE;

			var src = pre.getAttribute('data-src');

			var language = env.language;
			if (language === 'none') {
				// the language might be 'none' because there is no language set;
				// in this case, we want to use the extension as the language
				var extension = (/\.(\w+)$/.exec(src) || [, 'none'])[1];
				language = EXTENSIONS[extension] || extension;
			}

			// set language classes
			Prism.util.setLanguage(code, language);
			Prism.util.setLanguage(pre, language);

			// preload the language
			var autoloader = Prism.plugins.autoloader;
			if (autoloader) {
				autoloader.loadLanguages(language);
			}

			// load file
			loadFile(
				src,
				function (text) {
					// mark as loaded
					pre.setAttribute(STATUS_ATTR, STATUS_LOADED);

					// handle data-range
					var range = parseRange(pre.getAttribute('data-range'));
					if (range) {
						var lines = text.split(/\r\n?|\n/g);

						// the range is one-based and inclusive on both ends
						var start = range[0];
						var end = range[1] == null ? lines.length : range[1];

						if (start < 0) { start += lines.length; }
						start = Math.max(0, Math.min(start - 1, lines.length));
						if (end < 0) { end += lines.length; }
						end = Math.max(0, Math.min(end, lines.length));

						text = lines.slice(start, end).join('\n');

						// add data-start for line numbers
						if (!pre.hasAttribute('data-start')) {
							pre.setAttribute('data-start', String(start + 1));
						}
					}

					// highlight code
					code.textContent = text;
					Prism.highlightElement(code);
				},
				function (error) {
					// mark as failed
					pre.setAttribute(STATUS_ATTR, STATUS_FAILED);

					code.textContent = error;
				}
			);
		}
	});

	Prism.plugins.fileHighlight = {
		/**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */
		highlight: function highlight(container) {
			var elements = (container || document).querySelectorAll(SELECTOR);

			for (var i = 0, element; (element = elements[i++]);) {
				Prism.highlightElement(element);
			}
		}
	};

	var logged = false;
	/** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */
	Prism.fileHighlight = function () {
		if (!logged) {
			console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
			logged = true;
		}
		Prism.plugins.fileHighlight.highlight.apply(this, arguments);
	};

}());

!function(e){function n(e,n){return e.replace(/<<(\d+)>>/g,(function(e,s){return"(?:"+n[+s]+")"}))}function s(e,s,a){return RegExp(n(e,s),a||"")}function a(e,n){for(var s=0;s<n;s++)e=e.replace(/<<self>>/g,(function(){return"(?:"+e+")"}));return e.replace(/<<self>>/g,"[^\\s\\S]")}var t="bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",r="class enum interface record struct",i="add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",o="abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield";function l(e){return"\\b(?:"+e.trim().replace(/ /g,"|")+")\\b"}var d=l(r),p=RegExp(l(t+" "+r+" "+i+" "+o)),c=l(r+" "+i+" "+o),u=l(t+" "+r+" "+o),g=a("<(?:[^<>;=+\\-*/%&|^]|<<self>>)*>",2),b=a("\\((?:[^()]|<<self>>)*\\)",2),h="@?\\b[A-Za-z_]\\w*\\b",f=n("<<0>>(?:\\s*<<1>>)?",[h,g]),m=n("(?!<<0>>)<<1>>(?:\\s*\\.\\s*<<1>>)*",[c,f]),k="\\[\\s*(?:,\\s*)*\\]",y=n("<<0>>(?:\\s*(?:\\?\\s*)?<<1>>)*(?:\\s*\\?)?",[m,k]),w=n("[^,()<>[\\];=+\\-*/%&|^]|<<0>>|<<1>>|<<2>>",[g,b,k]),v=n("\\(<<0>>+(?:,<<0>>+)+\\)",[w]),x=n("(?:<<0>>|<<1>>)(?:\\s*(?:\\?\\s*)?<<2>>)*(?:\\s*\\?)?",[v,m,k]),$={keyword:p,punctuation:/[<>()?,.:[\]]/},_="'(?:[^\r\n'\\\\]|\\\\.|\\\\[Uux][\\da-fA-F]{1,8})'",B='"(?:\\\\.|[^\\\\"\r\n])*"';e.languages.csharp=e.languages.extend("clike",{string:[{pattern:s("(^|[^$\\\\])<<0>>",['@"(?:""|\\\\[^]|[^\\\\"])*"(?!")']),lookbehind:!0,greedy:!0},{pattern:s("(^|[^@$\\\\])<<0>>",[B]),lookbehind:!0,greedy:!0}],"class-name":[{pattern:s("(\\busing\\s+static\\s+)<<0>>(?=\\s*;)",[m]),lookbehind:!0,inside:$},{pattern:s("(\\busing\\s+<<0>>\\s*=\\s*)<<1>>(?=\\s*;)",[h,x]),lookbehind:!0,inside:$},{pattern:s("(\\busing\\s+)<<0>>(?=\\s*=)",[h]),lookbehind:!0},{pattern:s("(\\b<<0>>\\s+)<<1>>",[d,f]),lookbehind:!0,inside:$},{pattern:s("(\\bcatch\\s*\\(\\s*)<<0>>",[m]),lookbehind:!0,inside:$},{pattern:s("(\\bwhere\\s+)<<0>>",[h]),lookbehind:!0},{pattern:s("(\\b(?:is(?:\\s+not)?|as)\\s+)<<0>>",[y]),lookbehind:!0,inside:$},{pattern:s("\\b<<0>>(?=\\s+(?!<<1>>|with\\s*\\{)<<2>>(?:\\s*[=,;:{)\\]]|\\s+(?:in|when)\\b))",[x,u,h]),inside:$}],keyword:p,number:/(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,operator:/>>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,punctuation:/\?\.?|::|[{}[\];(),.:]/}),e.languages.insertBefore("csharp","number",{range:{pattern:/\.\./,alias:"operator"}}),e.languages.insertBefore("csharp","punctuation",{"named-parameter":{pattern:s("([(,]\\s*)<<0>>(?=\\s*:)",[h]),lookbehind:!0,alias:"punctuation"}}),e.languages.insertBefore("csharp","class-name",{namespace:{pattern:s("(\\b(?:namespace|using)\\s+)<<0>>(?:\\s*\\.\\s*<<0>>)*(?=\\s*[;{])",[h]),lookbehind:!0,inside:{punctuation:/\./}},"type-expression":{pattern:s("(\\b(?:default|sizeof|typeof)\\s*\\(\\s*(?!\\s))(?:[^()\\s]|\\s(?!\\s)|<<0>>)*(?=\\s*\\))",[b]),lookbehind:!0,alias:"class-name",inside:$},"return-type":{pattern:s("<<0>>(?=\\s+(?:<<1>>\\s*(?:=>|[({]|\\.\\s*this\\s*\\[)|this\\s*\\[))",[x,m]),inside:$,alias:"class-name"},"constructor-invocation":{pattern:s("(\\bnew\\s+)<<0>>(?=\\s*[[({])",[x]),lookbehind:!0,inside:$,alias:"class-name"},"generic-method":{pattern:s("<<0>>\\s*<<1>>(?=\\s*\\()",[h,g]),inside:{function:s("^<<0>>",[h]),generic:{pattern:RegExp(g),alias:"class-name",inside:$}}},"type-list":{pattern:s("\\b((?:<<0>>\\s+<<1>>|record\\s+<<1>>\\s*<<5>>|where\\s+<<2>>)\\s*:\\s*)(?:<<3>>|<<4>>|<<1>>\\s*<<5>>|<<6>>)(?:\\s*,\\s*(?:<<3>>|<<4>>|<<6>>))*(?=\\s*(?:where|[{;]|=>|$))",[d,f,h,x,p.source,b,"\\bnew\\s*\\(\\s*\\)"]),lookbehind:!0,inside:{"record-arguments":{pattern:s("(^(?!new\\s*\\()<<0>>\\s*)<<1>>",[f,b]),lookbehind:!0,greedy:!0,inside:e.languages.csharp},keyword:p,"class-name":{pattern:RegExp(x),greedy:!0,inside:$},punctuation:/[,()]/}},preprocessor:{pattern:/(^[\t ]*)#.*/m,lookbehind:!0,alias:"property",inside:{directive:{pattern:/(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,lookbehind:!0,alias:"keyword"}}}});var E=B+"|"+_,R=n("/(?![*/])|//[^\r\n]*[\r\n]|/\\*(?:[^*]|\\*(?!/))*\\*/|<<0>>",[E]),z=a(n("[^\"'/()]|<<0>>|\\(<<self>>*\\)",[R]),2),S="\\b(?:assembly|event|field|method|module|param|property|return|type)\\b",j=n("<<0>>(?:\\s*\\(<<1>>*\\))?",[m,z]);e.languages.insertBefore("csharp","class-name",{attribute:{pattern:s("((?:^|[^\\s\\w>)?])\\s*\\[\\s*)(?:<<0>>\\s*:\\s*)?<<1>>(?:\\s*,\\s*<<1>>)*(?=\\s*\\])",[S,j]),lookbehind:!0,greedy:!0,inside:{target:{pattern:s("^<<0>>(?=\\s*:)",[S]),alias:"keyword"},"attribute-arguments":{pattern:s("\\(<<0>>*\\)",[z]),inside:e.languages.csharp},"class-name":{pattern:RegExp(m),inside:{punctuation:/\./}},punctuation:/[:,]/}}});var A=":[^}\r\n]+",F=a(n("[^\"'/()]|<<0>>|\\(<<self>>*\\)",[R]),2),P=n("\\{(?!\\{)(?:(?![}:])<<0>>)*<<1>>?\\}",[F,A]),U=a(n("[^\"'/()]|/(?!\\*)|/\\*(?:[^*]|\\*(?!/))*\\*/|<<0>>|\\(<<self>>*\\)",[E]),2),Z=n("\\{(?!\\{)(?:(?![}:])<<0>>)*<<1>>?\\}",[U,A]);function q(n,a){return{interpolation:{pattern:s("((?:^|[^{])(?:\\{\\{)*)<<0>>",[n]),lookbehind:!0,inside:{"format-string":{pattern:s("(^\\{(?:(?![}:])<<0>>)*)<<1>>(?=\\}$)",[a,A]),lookbehind:!0,inside:{punctuation:/^:/}},punctuation:/^\{|\}$/,expression:{pattern:/[\s\S]+/,alias:"language-csharp",inside:e.languages.csharp}}},string:/[\s\S]+/}}e.languages.insertBefore("csharp","string",{"interpolation-string":[{pattern:s('(^|[^\\\\])(?:\\$@|@\\$)"(?:""|\\\\[^]|\\{\\{|<<0>>|[^\\\\{"])*"',[P]),lookbehind:!0,greedy:!0,inside:q(P,F)},{pattern:s('(^|[^@\\\\])\\$"(?:\\\\.|\\{\\{|<<0>>|[^\\\\"{])*"',[Z]),lookbehind:!0,greedy:!0,inside:q(Z,U)}],char:{pattern:RegExp(_),greedy:!0}}),e.languages.dotnet=e.languages.cs=e.languages.csharp}(Prism);
!function(s){var e=/(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;s.languages.css={comment:/\/\*[\s\S]*?\*\//,atrule:{pattern:RegExp("@[\\w-](?:[^;{\\s\"']|\\s+(?!\\s)|"+e.source+")*?(?:;|(?=\\s*\\{))"),inside:{rule:/^@[\w-]+/,"selector-function-argument":{pattern:/(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,lookbehind:!0,alias:"selector"},keyword:{pattern:/(^|[^\w-])(?:and|not|only|or)(?![\w-])/,lookbehind:!0}}},url:{pattern:RegExp("\\burl\\((?:"+e.source+"|(?:[^\\\\\r\n()\"']|\\\\[^])*)\\)","i"),greedy:!0,inside:{function:/^url/i,punctuation:/^\(|\)$/,string:{pattern:RegExp("^"+e.source+"$"),alias:"url"}}},selector:{pattern:RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|"+e.source+")*(?=\\s*\\{)"),lookbehind:!0},string:{pattern:e,greedy:!0},property:{pattern:/(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,lookbehind:!0},important:/!important\b/i,function:{pattern:/(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,lookbehind:!0},punctuation:/[(){};:,]/},s.languages.css.atrule.inside.rest=s.languages.css;var t=s.languages.markup;t&&(t.tag.addInlined("style","css"),t.tag.addAttribute("style","css"))}(Prism);
!function(e){e.languages.typescript=e.languages.extend("javascript",{"class-name":{pattern:/(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,lookbehind:!0,greedy:!0,inside:null},builtin:/\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/}),e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/,/\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,/\btype\b(?=\s*(?:[\{*]|$))/),delete e.languages.typescript.parameter,delete e.languages.typescript["literal-property"];var s=e.languages.extend("typescript",{});delete s["class-name"],e.languages.typescript["class-name"].inside=s,e.languages.insertBefore("typescript","function",{decorator:{pattern:/@[$\w\xA0-\uFFFF]+/,inside:{at:{pattern:/^@/,alias:"operator"},function:/^[\s\S]+/}},"generic-function":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,greedy:!0,inside:{function:/^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,generic:{pattern:/<[\s\S]+/,alias:"class-name",inside:s}}}}),e.languages.ts=e.languages.typescript}(Prism);
Prism.languages.python={comment:{pattern:/(^|[^\\])#.*/,lookbehind:!0,greedy:!0},"string-interpolation":{pattern:/(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,greedy:!0,inside:{interpolation:{pattern:/((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,lookbehind:!0,inside:{"format-spec":{pattern:/(:)[^:(){}]+(?=\}$)/,lookbehind:!0},"conversion-option":{pattern:/![sra](?=[:}]$)/,alias:"punctuation"},rest:null}},string:/[\s\S]+/}},"triple-quoted-string":{pattern:/(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,greedy:!0,alias:"string"},string:{pattern:/(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,greedy:!0},function:{pattern:/((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,lookbehind:!0},"class-name":{pattern:/(\bclass\s+)\w+/i,lookbehind:!0},decorator:{pattern:/(^[\t ]*)@\w+(?:\.\w+)*/m,lookbehind:!0,alias:["annotation","punctuation"],inside:{punctuation:/\./}},keyword:/\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,builtin:/\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,boolean:/\b(?:False|None|True)\b/,number:/\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,operator:/[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,punctuation:/[{}[\];(),.:]/},Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest=Prism.languages.python,Prism.languages.py=Prism.languages.python;
!function(e){var n=/\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/,t="(?:[a-z]\\w*\\s*\\.\\s*)*(?:[A-Z]\\w*\\s*\\.\\s*)*",s={pattern:RegExp("(^|[^\\w.])"+t+"[A-Z](?:[\\d_A-Z]*[a-z]\\w*)?\\b"),lookbehind:!0,inside:{namespace:{pattern:/^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,inside:{punctuation:/\./}},punctuation:/\./}};e.languages.java=e.languages.extend("clike",{string:{pattern:/(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,lookbehind:!0,greedy:!0},"class-name":[s,{pattern:RegExp("(^|[^\\w.])"+t+"[A-Z]\\w*(?=\\s+\\w+\\s*[;,=()]|\\s*(?:\\[[\\s,]*\\]\\s*)?::\\s*new\\b)"),lookbehind:!0,inside:s.inside},{pattern:RegExp("(\\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\\s+)"+t+"[A-Z]\\w*\\b"),lookbehind:!0,inside:s.inside}],keyword:n,function:[e.languages.clike.function,{pattern:/(::\s*)[a-z_]\w*/,lookbehind:!0}],number:/\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,operator:{pattern:/(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,lookbehind:!0},constant:/\b[A-Z][A-Z_\d]+\b/}),e.languages.insertBefore("java","string",{"triple-quoted-string":{pattern:/"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,greedy:!0,alias:"string"},char:{pattern:/'(?:\\.|[^'\\\r\n]){1,6}'/,greedy:!0}}),e.languages.insertBefore("java","class-name",{annotation:{pattern:/(^|[^.])@\w+(?:\s*\.\s*\w+)*/,lookbehind:!0,alias:"punctuation"},generics:{pattern:/<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,inside:{"class-name":s,keyword:n,punctuation:/[<>(),.:]/,operator:/[?&|]/}},import:[{pattern:RegExp("(\\bimport\\s+)"+t+"(?:[A-Z]\\w*|\\*)(?=\\s*;)"),lookbehind:!0,inside:{namespace:s.inside.namespace,punctuation:/\./,operator:/\*/,"class-name":/\w+/}},{pattern:RegExp("(\\bimport\\s+static\\s+)"+t+"(?:\\w+|\\*)(?=\\s*;)"),lookbehind:!0,alias:"static",inside:{namespace:s.inside.namespace,static:/\b\w+$/,punctuation:/\./,operator:/\*/,"class-name":/\w+/}}],namespace:{pattern:RegExp("(\\b(?:exports|import(?:\\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\\s+)(?!<keyword>)[a-z]\\w*(?:\\.[a-z]\\w*)*\\.?".replace(/<keyword>/g,(function(){return n.source}))),lookbehind:!0,inside:{punctuation:/\./}}})}(Prism);
Prism.languages.json={property:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,lookbehind:!0,greedy:!0},string:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,lookbehind:!0,greedy:!0},comment:{pattern:/\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,greedy:!0},number:/-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,punctuation:/[{}[\],]/,operator:/:/,boolean:/\b(?:false|true)\b/,null:{pattern:/\bnull\b/,alias:"keyword"}},Prism.languages.webmanifest=Prism.languages.json;
Prism.languages.javascript=Prism.languages.extend("clike",{"class-name":[Prism.languages.clike["class-name"],{pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,lookbehind:!0}],keyword:[{pattern:/((?:^|\})\s*)catch\b/,lookbehind:!0},{pattern:/(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,lookbehind:!0}],function:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,number:{pattern:RegExp("(^|[^\\w$])(?:NaN|Infinity|0[bB][01]+(?:_[01]+)*n?|0[oO][0-7]+(?:_[0-7]+)*n?|0[xX][\\dA-Fa-f]+(?:_[\\dA-Fa-f]+)*n?|\\d+(?:_\\d+)*n|(?:\\d+(?:_\\d+)*(?:\\.(?:\\d+(?:_\\d+)*)?)?|\\.\\d+(?:_\\d+)*)(?:[Ee][+-]?\\d+(?:_\\d+)*)?)(?![\\w$])"),lookbehind:!0},operator:/--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/}),Prism.languages.javascript["class-name"][0].pattern=/(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/,Prism.languages.insertBefore("javascript","keyword",{regex:{pattern:RegExp("((?:^|[^$\\w\\xA0-\\uFFFF.\"'\\])\\s]|\\b(?:return|yield))\\s*)/(?:(?:\\[(?:[^\\]\\\\\r\n]|\\\\.)*\\]|\\\\.|[^/\\\\\\[\r\n])+/[dgimyus]{0,7}|(?:\\[(?:[^[\\]\\\\\r\n]|\\\\.|\\[(?:[^[\\]\\\\\r\n]|\\\\.|\\[(?:[^[\\]\\\\\r\n]|\\\\.)*\\])*\\])*\\]|\\\\.|[^/\\\\\\[\r\n])+/[dgimyus]{0,7}v[dgimyus]{0,7})(?=(?:\\s|/\\*(?:[^*]|\\*(?!/))*\\*/)*(?:$|[\r\n,.;:})\\]]|//))"),lookbehind:!0,greedy:!0,inside:{"regex-source":{pattern:/^(\/)[\s\S]+(?=\/[a-z]*$)/,lookbehind:!0,alias:"language-regex",inside:Prism.languages.regex},"regex-delimiter":/^\/|\/$/,"regex-flags":/^[a-z]+$/}},"function-variable":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,alias:"function"},parameter:[{pattern:/(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,lookbehind:!0,inside:Prism.languages.javascript},{pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,lookbehind:!0,inside:Prism.languages.javascript},{pattern:/(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,lookbehind:!0,inside:Prism.languages.javascript},{pattern:/((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,lookbehind:!0,inside:Prism.languages.javascript}],constant:/\b[A-Z](?:[A-Z_]|\dx?)*\b/}),Prism.languages.insertBefore("javascript","string",{hashbang:{pattern:/^#!.*/,greedy:!0,alias:"comment"},"template-string":{pattern:/`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,greedy:!0,inside:{"template-punctuation":{pattern:/^`|`$/,alias:"string"},interpolation:{pattern:/((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,lookbehind:!0,inside:{"interpolation-punctuation":{pattern:/^\$\{|\}$/,alias:"punctuation"},rest:Prism.languages.javascript}},string:/[\s\S]+/}},"string-property":{pattern:/((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,lookbehind:!0,greedy:!0,alias:"property"}}),Prism.languages.insertBefore("javascript","operator",{"literal-property":{pattern:/((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,lookbehind:!0,alias:"property"}}),Prism.languages.markup&&(Prism.languages.markup.tag.addInlined("script","javascript"),Prism.languages.markup.tag.addAttribute("on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)","javascript")),Prism.languages.js=Prism.languages.javascript;
Prism.languages.go=Prism.languages.extend("clike",{string:{pattern:/(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,lookbehind:!0,greedy:!0},keyword:/\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,boolean:/\b(?:_|false|iota|nil|true)\b/,number:[/\b0(?:b[01_]+|o[0-7_]+)i?\b/i,/\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,/(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i],operator:/[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,builtin:/\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/}),Prism.languages.insertBefore("go","string",{char:{pattern:/'(?:\\.|[^'\\\r\n]){0,10}'/,greedy:!0}}),delete Prism.languages.go["class-name"];
!function(e){for(var a="/\\*(?:[^*/]|\\*(?!/)|/(?!\\*)|<self>)*\\*/",t=0;t<2;t++)a=a.replace(/<self>/g,(function(){return a}));a=a.replace(/<self>/g,(function(){return"[^\\s\\S]"})),e.languages.rust={comment:[{pattern:RegExp("(^|[^\\\\])"+a),lookbehind:!0,greedy:!0},{pattern:/(^|[^\\:])\/\/.*/,lookbehind:!0,greedy:!0}],string:{pattern:/b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,greedy:!0},char:{pattern:/b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,greedy:!0},attribute:{pattern:/#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,greedy:!0,alias:"attr-name",inside:{string:null}},"closure-params":{pattern:/([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,lookbehind:!0,greedy:!0,inside:{"closure-punctuation":{pattern:/^\||\|$/,alias:"punctuation"},rest:null}},"lifetime-annotation":{pattern:/'\w+/,alias:"symbol"},"fragment-specifier":{pattern:/(\$\w+:)[a-z]+/,lookbehind:!0,alias:"punctuation"},variable:/\$\w+/,"function-definition":{pattern:/(\bfn\s+)\w+/,lookbehind:!0,alias:"function"},"type-definition":{pattern:/(\b(?:enum|struct|trait|type|union)\s+)\w+/,lookbehind:!0,alias:"class-name"},"module-declaration":[{pattern:/(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,lookbehind:!0,alias:"namespace"},{pattern:/(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,lookbehind:!0,alias:"namespace",inside:{punctuation:/::/}}],keyword:[/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,/\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/],function:/\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,macro:{pattern:/\b\w+!/,alias:"property"},constant:/\b[A-Z_][A-Z_\d]+\b/,"class-name":/\b[A-Z]\w*\b/,namespace:{pattern:/(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,inside:{punctuation:/::/}},number:/\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,boolean:/\b(?:false|true)\b/,punctuation:/->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,operator:/[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/},e.languages.rust["closure-params"].inside.rest=e.languages.rust,e.languages.rust.attribute.inside.string=e.languages.rust.string}(Prism);
(function () {

	if (typeof Prism === 'undefined' || typeof document === 'undefined') {
		return;
	}

	/**
	 * Plugin name which is used as a class name for <pre> which is activating the plugin
	 *
	 * @type {string}
	 */
	var PLUGIN_NAME = 'line-numbers';

	/**
	 * Regular expression used for determining line breaks
	 *
	 * @type {RegExp}
	 */
	var NEW_LINE_EXP = /\n(?!$)/g;


	/**
	 * Global exports
	 */
	var config = Prism.plugins.lineNumbers = {
		/**
		 * Get node for provided line number
		 *
		 * @param {Element} element pre element
		 * @param {number} number line number
		 * @returns {Element|undefined}
		 */
		getLine: function (element, number) {
			if (element.tagName !== 'PRE' || !element.classList.contains(PLUGIN_NAME)) {
				return;
			}

			var lineNumberRows = element.querySelector('.line-numbers-rows');
			if (!lineNumberRows) {
				return;
			}
			var lineNumberStart = parseInt(element.getAttribute('data-start'), 10) || 1;
			var lineNumberEnd = lineNumberStart + (lineNumberRows.children.length - 1);

			if (number < lineNumberStart) {
				number = lineNumberStart;
			}
			if (number > lineNumberEnd) {
				number = lineNumberEnd;
			}

			var lineIndex = number - lineNumberStart;

			return lineNumberRows.children[lineIndex];
		},

		/**
		 * Resizes the line numbers of the given element.
		 *
		 * This function will not add line numbers. It will only resize existing ones.
		 *
		 * @param {HTMLElement} element A `<pre>` element with line numbers.
		 * @returns {void}
		 */
		resize: function (element) {
			resizeElements([element]);
		},

		/**
		 * Whether the plugin can assume that the units font sizes and margins are not depended on the size of
		 * the current viewport.
		 *
		 * Setting this to `true` will allow the plugin to do certain optimizations for better performance.
		 *
		 * Set this to `false` if you use any of the following CSS units: `vh`, `vw`, `vmin`, `vmax`.
		 *
		 * @type {boolean}
		 */
		assumeViewportIndependence: true
	};

	/**
	 * Resizes the given elements.
	 *
	 * @param {HTMLElement[]} elements
	 */
	function resizeElements(elements) {
		elements = elements.filter(function (e) {
			var codeStyles = getStyles(e);
			var whiteSpace = codeStyles['white-space'];
			return whiteSpace === 'pre-wrap' || whiteSpace === 'pre-line';
		});

		if (elements.length == 0) {
			return;
		}

		var infos = elements.map(function (element) {
			var codeElement = element.querySelector('code');
			var lineNumbersWrapper = element.querySelector('.line-numbers-rows');
			if (!codeElement || !lineNumbersWrapper) {
				return undefined;
			}

			/** @type {HTMLElement} */
			var lineNumberSizer = element.querySelector('.line-numbers-sizer');
			var codeLines = codeElement.textContent.split(NEW_LINE_EXP);

			if (!lineNumberSizer) {
				lineNumberSizer = document.createElement('span');
				lineNumberSizer.className = 'line-numbers-sizer';

				codeElement.appendChild(lineNumberSizer);
			}

			lineNumberSizer.innerHTML = '0';
			lineNumberSizer.style.display = 'block';

			var oneLinerHeight = lineNumberSizer.getBoundingClientRect().height;
			lineNumberSizer.innerHTML = '';

			return {
				element: element,
				lines: codeLines,
				lineHeights: [],
				oneLinerHeight: oneLinerHeight,
				sizer: lineNumberSizer,
			};
		}).filter(Boolean);

		infos.forEach(function (info) {
			var lineNumberSizer = info.sizer;
			var lines = info.lines;
			var lineHeights = info.lineHeights;
			var oneLinerHeight = info.oneLinerHeight;

			lineHeights[lines.length - 1] = undefined;
			lines.forEach(function (line, index) {
				if (line && line.length > 1) {
					var e = lineNumberSizer.appendChild(document.createElement('span'));
					e.style.display = 'block';
					e.textContent = line;
				} else {
					lineHeights[index] = oneLinerHeight;
				}
			});
		});

		infos.forEach(function (info) {
			var lineNumberSizer = info.sizer;
			var lineHeights = info.lineHeights;

			var childIndex = 0;
			for (var i = 0; i < lineHeights.length; i++) {
				if (lineHeights[i] === undefined) {
					lineHeights[i] = lineNumberSizer.children[childIndex++].getBoundingClientRect().height;
				}
			}
		});

		infos.forEach(function (info) {
			var lineNumberSizer = info.sizer;
			var wrapper = info.element.querySelector('.line-numbers-rows');

			lineNumberSizer.style.display = 'none';
			lineNumberSizer.innerHTML = '';

			info.lineHeights.forEach(function (height, lineNumber) {
				wrapper.children[lineNumber].style.height = height + 'px';
			});
		});
	}

	/**
	 * Returns style declarations for the element
	 *
	 * @param {Element} element
	 */
	function getStyles(element) {
		if (!element) {
			return null;
		}

		return window.getComputedStyle ? getComputedStyle(element) : (element.currentStyle || null);
	}

	var lastWidth = undefined;
	window.addEventListener('resize', function () {
		if (config.assumeViewportIndependence && lastWidth === window.innerWidth) {
			return;
		}
		lastWidth = window.innerWidth;

		resizeElements(Array.prototype.slice.call(document.querySelectorAll('pre.' + PLUGIN_NAME)));
	});

	Prism.hooks.add('complete', function (env) {
		if (!env.code) {
			return;
		}

		var code = /** @type {Element} */ (env.element);
		var pre = /** @type {HTMLElement} */ (code.parentNode);

		// works only for <code> wrapped inside <pre> (not inline)
		if (!pre || !/pre/i.test(pre.nodeName)) {
			return;
		}

		// Abort if line numbers already exists
		if (code.querySelector('.line-numbers-rows')) {
			return;
		}

		// only add line numbers if <code> or one of its ancestors has the `line-numbers` class
		if (!Prism.util.isActive(code, PLUGIN_NAME)) {
			return;
		}

		// Remove the class 'line-numbers' from the <code>
		code.classList.remove(PLUGIN_NAME);
		// Add the class 'line-numbers' to the <pre>
		pre.classList.add(PLUGIN_NAME);

		var match = env.code.match(NEW_LINE_EXP);
		var linesNum = match ? match.length + 1 : 1;
		var lineNumbersWrapper;

		var lines = new Array(linesNum + 1).join('<span></span>');

		lineNumbersWrapper = document.createElement('span');
		lineNumbersWrapper.setAttribute('aria-hidden', 'true');
		lineNumbersWrapper.className = 'line-numbers-rows';
		lineNumbersWrapper.innerHTML = lines;

		if (pre.hasAttribute('data-start')) {
			pre.style.counterReset = 'linenumber ' + (parseInt(pre.getAttribute('data-start'), 10) - 1);
		}

		env.element.appendChild(lineNumbersWrapper);

		resizeElements([pre]);

		Prism.hooks.run('line-numbers', env);
	});

	Prism.hooks.add('line-numbers', function (env) {
		env.plugins = env.plugins || {};
		env.plugins.lineNumbers = true;
	});

}());

(function () {

	if (typeof Prism === 'undefined' || typeof document === 'undefined' || !document.querySelector) {
		return;
	}

	var LINE_NUMBERS_CLASS = 'line-numbers';
	var LINKABLE_LINE_NUMBERS_CLASS = 'linkable-line-numbers';
	var NEW_LINE_EXP = /\n(?!$)/g;

	/**
	 * @param {string} selector
	 * @param {ParentNode} [container]
	 * @returns {HTMLElement[]}
	 */
	function $$(selector, container) {
		return Array.prototype.slice.call((container || document).querySelectorAll(selector));
	}

	/**
	 * Returns whether the given element has the given class.
	 *
	 * @param {Element} element
	 * @param {string} className
	 * @returns {boolean}
	 */
	function hasClass(element, className) {
		return element.classList.contains(className);
	}

	/**
	 * Calls the given function.
	 *
	 * @param {() => any} func
	 * @returns {void}
	 */
	function callFunction(func) {
		func();
	}

	// Some browsers round the line-height, others don't.
	// We need to test for it to position the elements properly.
	var isLineHeightRounded = (function () {
		var res;
		return function () {
			if (typeof res === 'undefined') {
				var d = document.createElement('div');
				d.style.fontSize = '13px';
				d.style.lineHeight = '1.5';
				d.style.padding = '0';
				d.style.border = '0';
				d.innerHTML = '&nbsp;<br />&nbsp;';
				document.body.appendChild(d);
				// Browsers that round the line-height should have offsetHeight === 38
				// The others should have 39.
				res = d.offsetHeight === 38;
				document.body.removeChild(d);
			}
			return res;
		};
	}());

	/**
	 * Returns the top offset of the content box of the given parent and the content box of one of its children.
	 *
	 * @param {HTMLElement} parent
	 * @param {HTMLElement} child
	 */
	function getContentBoxTopOffset(parent, child) {
		var parentStyle = getComputedStyle(parent);
		var childStyle = getComputedStyle(child);

		/**
		 * Returns the numeric value of the given pixel value.
		 *
		 * @param {string} px
		 */
		function pxToNumber(px) {
			return +px.substr(0, px.length - 2);
		}

		return child.offsetTop
			+ pxToNumber(childStyle.borderTopWidth)
			+ pxToNumber(childStyle.paddingTop)
			- pxToNumber(parentStyle.paddingTop);
	}

	/**
	 * Returns whether the Line Highlight plugin is active for the given element.
	 *
	 * If this function returns `false`, do not call `highlightLines` for the given element.
	 *
	 * @param {HTMLElement | null | undefined} pre
	 * @returns {boolean}
	 */
	function isActiveFor(pre) {
		if (!pre || !/pre/i.test(pre.nodeName)) {
			return false;
		}

		if (pre.hasAttribute('data-line')) {
			return true;
		}

		if (pre.id && Prism.util.isActive(pre, LINKABLE_LINE_NUMBERS_CLASS)) {
			// Technically, the line numbers plugin is also necessary but this plugin doesn't control the classes of
			// the line numbers plugin, so we can't assume that they are present.
			return true;
		}

		return false;
	}

	var scrollIntoView = true;

	Prism.plugins.lineHighlight = {
		/**
		 * Highlights the lines of the given pre.
		 *
		 * This function is split into a DOM measuring and mutate phase to improve performance.
		 * The returned function mutates the DOM when called.
		 *
		 * @param {HTMLElement} pre
		 * @param {string | null} [lines]
		 * @param {string} [classes='']
		 * @returns {() => void}
		 */
		highlightLines: function highlightLines(pre, lines, classes) {
			lines = typeof lines === 'string' ? lines : (pre.getAttribute('data-line') || '');

			var ranges = lines.replace(/\s+/g, '').split(',').filter(Boolean);
			var offset = +pre.getAttribute('data-line-offset') || 0;

			var parseMethod = isLineHeightRounded() ? parseInt : parseFloat;
			var lineHeight = parseMethod(getComputedStyle(pre).lineHeight);
			var hasLineNumbers = Prism.util.isActive(pre, LINE_NUMBERS_CLASS);
			var codeElement = pre.querySelector('code');
			var parentElement = hasLineNumbers ? pre : codeElement || pre;
			var mutateActions = /** @type {(() => void)[]} */ ([]);
			var lineBreakMatch = codeElement.textContent.match(NEW_LINE_EXP);
			var numberOfLines = lineBreakMatch ? lineBreakMatch.length + 1 : 1;
			/**
			 * The top offset between the content box of the <code> element and the content box of the parent element of
			 * the line highlight element (either `<pre>` or `<code>`).
			 *
			 * This offset might not be zero for some themes where the <code> element has a top margin. Some plugins
			 * (or users) might also add element above the <code> element. Because the line highlight is aligned relative
			 * to the <pre> element, we have to take this into account.
			 *
			 * This offset will be 0 if the parent element of the line highlight element is the `<code>` element.
			 */
			var codePreOffset = !codeElement || parentElement == codeElement ? 0 : getContentBoxTopOffset(pre, codeElement);

			ranges.forEach(function (currentRange) {
				var range = currentRange.split('-');

				var start = +range[0];
				var end = +range[1] || start;
				end = Math.min(numberOfLines + offset, end);

				if (end < start) {
					return;
				}

				/** @type {HTMLElement} */
				var line = pre.querySelector('.line-highlight[data-range="' + currentRange + '"]') || document.createElement('div');

				mutateActions.push(function () {
					line.setAttribute('aria-hidden', 'true');
					line.setAttribute('data-range', currentRange);
					line.className = (classes || '') + ' line-highlight';
				});

				// if the line-numbers plugin is enabled, then there is no reason for this plugin to display the line numbers
				if (hasLineNumbers && Prism.plugins.lineNumbers) {
					var startNode = Prism.plugins.lineNumbers.getLine(pre, start);
					var endNode = Prism.plugins.lineNumbers.getLine(pre, end);

					if (startNode) {
						var top = startNode.offsetTop + codePreOffset + 'px';
						mutateActions.push(function () {
							line.style.top = top;
						});
					}

					if (endNode) {
						var height = (endNode.offsetTop - startNode.offsetTop) + endNode.offsetHeight + 'px';
						mutateActions.push(function () {
							line.style.height = height;
						});
					}
				} else {
					mutateActions.push(function () {
						line.setAttribute('data-start', String(start));

						if (end > start) {
							line.setAttribute('data-end', String(end));
						}

						line.style.top = (start - offset - 1) * lineHeight + codePreOffset + 'px';

						line.textContent = new Array(end - start + 2).join(' \n');
					});
				}

				mutateActions.push(function () {
					line.style.width = pre.scrollWidth + 'px';
				});

				mutateActions.push(function () {
					// allow this to play nicely with the line-numbers plugin
					// need to attack to pre as when line-numbers is enabled, the code tag is relatively which screws up the positioning
					parentElement.appendChild(line);
				});
			});

			var id = pre.id;
			if (hasLineNumbers && Prism.util.isActive(pre, LINKABLE_LINE_NUMBERS_CLASS) && id) {
				// This implements linkable line numbers. Linkable line numbers use Line Highlight to create a link to a
				// specific line. For this to work, the pre element has to:
				//  1) have line numbers,
				//  2) have the `linkable-line-numbers` class or an ascendant that has that class, and
				//  3) have an id.

				if (!hasClass(pre, LINKABLE_LINE_NUMBERS_CLASS)) {
					// add class to pre
					mutateActions.push(function () {
						pre.classList.add(LINKABLE_LINE_NUMBERS_CLASS);
					});
				}

				var start = parseInt(pre.getAttribute('data-start') || '1');

				// iterate all line number spans
				$$('.line-numbers-rows > span', pre).forEach(function (lineSpan, i) {
					var lineNumber = i + start;
					lineSpan.onclick = function () {
						var hash = id + '.' + lineNumber;

						// this will prevent scrolling since the span is obviously in view
						scrollIntoView = false;
						location.hash = hash;
						setTimeout(function () {
							scrollIntoView = true;
						}, 1);
					};
				});
			}

			return function () {
				mutateActions.forEach(callFunction);
			};
		}
	};


	function applyHash() {
		var hash = location.hash.slice(1);

		// Remove pre-existing temporary lines
		$$('.temporary.line-highlight').forEach(function (line) {
			line.parentNode.removeChild(line);
		});

		var range = (hash.match(/\.([\d,-]+)$/) || [, ''])[1];

		if (!range || document.getElementById(hash)) {
			return;
		}

		var id = hash.slice(0, hash.lastIndexOf('.'));
		var pre = document.getElementById(id);

		if (!pre) {
			return;
		}

		if (!pre.hasAttribute('data-line')) {
			pre.setAttribute('data-line', '');
		}

		var mutateDom = Prism.plugins.lineHighlight.highlightLines(pre, range, 'temporary ');
		mutateDom();

		if (scrollIntoView) {
			document.querySelector('.temporary.line-highlight').scrollIntoView();
		}
	}

	var fakeTimer = 0; // Hack to limit the number of times applyHash() runs

	Prism.hooks.add('before-sanity-check', function (env) {
		var pre = env.element.parentElement;
		if (!isActiveFor(pre)) {
			return;
		}

		/*
		 * Cleanup for other plugins (e.g. autoloader).
		 *
		 * Sometimes <code> blocks are highlighted multiple times. It is necessary
		 * to cleanup any left-over tags, because the whitespace inside of the <div>
		 * tags change the content of the <code> tag.
		 */
		var num = 0;
		$$('.line-highlight', pre).forEach(function (line) {
			num += line.textContent.length;
			line.parentNode.removeChild(line);
		});
		// Remove extra whitespace
		if (num && /^(?: \n)+$/.test(env.code.slice(-num))) {
			env.code = env.code.slice(0, -num);
		}
	});

	Prism.hooks.add('complete', function completeHook(env) {
		var pre = env.element.parentElement;
		if (!isActiveFor(pre)) {
			return;
		}

		clearTimeout(fakeTimer);

		var hasLineNumbers = Prism.plugins.lineNumbers;
		var isLineNumbersLoaded = env.plugins && env.plugins.lineNumbers;

		if (hasClass(pre, LINE_NUMBERS_CLASS) && hasLineNumbers && !isLineNumbersLoaded) {
			Prism.hooks.add('line-numbers', completeHook);
		} else {
			var mutateDom = Prism.plugins.lineHighlight.highlightLines(pre);
			mutateDom();
			fakeTimer = setTimeout(applyHash, 1);
		}
	});

	window.addEventListener('hashchange', applyHash);
	window.addEventListener('resize', function () {
		var actions = $$('pre')
			.filter(isActiveFor)
			.map(function (pre) {
				return Prism.plugins.lineHighlight.highlightLines(pre);
			});
		actions.forEach(callFunction);
	});

}());

/*! For license information please see main.js.LICENSE.txt */
(()=>{"use strict";const e="0.0.1";var t={"./src/application.ts":(e,t,r)=>{r.r(t),r.d(t,{Application:()=>d});var s=r("./src/infrastructure/api.ts"),i=r("./src/services/authService/authConstans.ts"),n=r("./src/infrastructure/httpURL/index.ts"),o=r("./src/core/constants.ts"),c=r("./src/infrastructure/adapters/index.ts"),a=r("./src/infrastructure/crypto/cryptoChannel.ts"),u=r("./src/infrastructure/devices/deviceInfo.ts"),h=r("./src/lib/index.ts");class d{constructor(){this.constants={chat:o.default.chat,auth:i.default},this.chat=new c.ChatAdapter,this.user=new c.UserAdapter,this.auth=new c.AuthAdapter(void 0,this.user),this.lib={http:{client:s.api.client,url:e=>new n.HttpURL(e)},crypto:{uuidV4:h.uuidV4,Channel:a.CryptoChannel},device:{Info:u.DeviceInfo},logger:h.logger}}}},"./src/core/chat.ts":(e,t,r)=>{r.r(t),r.d(t,{Chat:()=>i});var s=r("./src/core/chatMessage/index.ts");class i{constructor(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:new s.ChatMessageFactory;this.messages=e,this.setting=t,this.factory=r}clearMessage(){return new i([],this.setting)}createMessageUser(e){const t=s.ChatMessageFactory.createMessageUser(e);return this.writeMessage(t)}createMessageBot(e,t){const r=s.ChatMessageFactory.createMessageBot(e,t);return this.writeMessage(r)}getLastMessage(){const e=this.messages.at(-1);if(e)return e;throw new Error("Message not found")}getLastMessages(e){if(e>this.messages.length)throw new Error("Messages count must be less than all messages length");const t=this.messages.length-e;return this.messages.slice(t)}getSetting(){return this.setting}getMessages(){return this.messages}mergeMessage(e){const t=[...this.messages,...e];return new i(t,this.setting)}writeMessage(e){const t=[...this.messages,e];return new i(t,this.setting)}writeMessages(e){return new i(e,this.setting)}writeSetting(e){return new i(this.messages,e)}}},"./src/core/chatMessage/chatMessage.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatMessage:()=>s});class s{constructor(e){this.message=e}}},"./src/core/chatMessage/chatMessage.types.ts":(e,t,r)=>{var s;r.r(t),r.d(t,{eMessageBotPlanType:()=>s}),r("./src/core/constants.ts"),function(e){e.TRIAL="TRIAL",e.BALANCE="BALANCE"}(s||(s={}))},"./src/core/chatMessage/chatMessageBot.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatMessageBot:()=>i});var s=r("./src/core/chatMessage/chatMessage.ts");class i extends s.ChatMessage{constructor(e){super(e),this.message=e}get(){return this.message}}},"./src/core/chatMessage/chatMessageFactory.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatMessageFactory:()=>o});var s=r("./src/core/constants.ts"),i=r("./src/core/chatMessage/chatMessageUser.ts"),n=(r("./src/core/chatMessage/chatMessage.ts"),r("./src/core/chatMessage/chatMessageBot.ts"));class o{static createMessageUser(e){const t={value:e,sender:s.default.chat.MESSAGE_SENDER.user};return new i.ChatMessageUser(t)}static createMessageBot(e,t){const r={value:e,sender:s.default.chat.MESSAGE_SENDER.bot,options:t};return new n.ChatMessageBot(r)}createMessage(e){if(e.sender===s.default.chat.MESSAGE_SENDER.user)return new i.ChatMessageUser(e);if(e.sender===s.default.chat.MESSAGE_SENDER.bot)return new n.ChatMessageBot(e);throw new Error("Unknown sender type")}}},"./src/core/chatMessage/chatMessageUser.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatMessageUser:()=>i});var s=r("./src/core/chatMessage/chatMessage.ts");class i extends s.ChatMessage{constructor(e){super(e),this.message=e}get(){return this.message}}},"./src/core/chatMessage/index.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatMessage:()=>s.ChatMessage,ChatMessageFactory:()=>i.ChatMessageFactory});var s=r("./src/core/chatMessage/chatMessage.ts"),i=r("./src/core/chatMessage/chatMessageFactory.ts")},"./src/core/chatSetting.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatSetting:()=>s});class s{constructor(e){this.setting=e}write(e){return new s(e)}get(){return this.setting}}},"./src/core/constants.ts":(e,t,r)=>{r.r(t),r.d(t,{MESSAGES_HISTORY_SIZE:()=>d,MESSAGE_SENDER:()=>i,SETTING_DATA_SOURCE_TYPE:()=>h,SETTING_IMG_RESPONSE_AS:()=>u,SETTING_IMG_SIZE:()=>a,default:()=>l,eChatSettingModel:()=>o,eChatSettingTokenLength:()=>n,eChatSettingTone:()=>c});var s=r("./src/core/chatMessage/chatMessage.types.ts");const i={bot:"ASSISTANT",user:"USER"};var n,o,c;!function(e){e[e.short=256]="short",e[e.medium=512]="medium",e[e.long=1024]="long",e[e.huge=2500]="huge"}(n||(n={})),function(e){e.GPT_4="GPT_4",e.GPT_52_CHAT_2025_12_11="GPT_52_CHAT_2025_12_11"}(o||(o={})),function(e){e.FORMAL="Respond in a formal tone, using proper language and etiquette.",e.INFORMAL="Keep it casual and relaxed in our conversation, no need for formalities."}(c||(c={}));const a={SMALL:"SMALL",MEDIUM:"MEDIUM",BIG:"BIG"},u={BASE_64:"BASE_64",URL:"URL"},h={COPILOT:"COPILOT",REAL_TIME:"REAL_TIME",BING:"BING"},d=2,l={chat:{MESSAGE_SENDER:i,TONE_BASE:"You are 'R2 Copilot' - an intelligent assistant. ",SETTING_TOKEN_LENGTH:n,SETTING_MODEL:o,SETTING_TONE:c,SETTING_PLAN_TYPE:s.eMessageBotPlanType,SETTING_IMG_SIZE:a,SETTING_IMG_RESPONSE_AS:u,SETTING_DATA_SOURCE_TYPE:h}}},"./src/core/user.ts":(e,t,r)=>{r.r(t),r.d(t,{User:()=>s});class s{constructor(e){this.user=e}get(){return this.user}}},"./src/infrastructure/adapters/authAdapter.ts":(e,t,r)=>{r.r(t),r.d(t,{AuthAdapter:()=>d});var s=r("./src/services/authService/index.ts"),i=(r("./src/services/authService/authService.types.ts"),r("./src/services/authService/authConstans.ts")),n=r("./src/infrastructure/api.ts"),o=r("./src/lib/subject.ts"),c=r("./src/infrastructure/observers/index.ts"),a=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))};const u=new o.Subject,h=new c.ObserverAuthImpl(u);class d{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:i.default.AUTH_OPTIONS_INIT,t=arguments.length>1?arguments[1]:void 0;this.user=t,this.subscribeOnUpdateLoggedIn=h.subscribeOnUpdateLoggedIn.bind(h),this.unSubscribeOnUpdateLoggedIn=h.unSubscribeOnUpdateLoggedIn.bind(h),this.authService=s.AuthService.init(e,n.api,this.user)}checkSession(){return a(this,void 0,void 0,(function*(){const e=yield this.authService.checkSession();return e?(u.notify(!0),e):(u.notify(!1),e)}))}getAuthLink(e){return this.authService.getAuthLink(e)}logout(e){return a(this,void 0,void 0,(function*(){yield this.authService.logout(e),u.notify(!1)}))}processCallback(e){return a(this,void 0,void 0,(function*(){try{yield this.authService.processCallback(e),u.notify(!0)}catch(e){u.notify(!1)}}))}setOptions(e){this.authService.setOptions(e)}}},"./src/infrastructure/adapters/chatAdapter.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatAdapter:()=>v}),r("./src/services/chatService/chatService.types.ts");var s=r("./src/services/chatService/index.ts"),i=r("./src/core/constants.ts"),n=r("./src/infrastructure/chatRepositoryInMemory.ts"),o=r("./src/infrastructure/api.ts"),c=(r("./src/core/chatMessage/index.ts"),r("./src/lib/subject.ts")),a=r("./src/infrastructure/observers/index.ts"),u=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))};const h=new c.Subject,d=new c.Subject,l=new a.ObserverChatImpl(h,d),{chat:p}=i.default,g={systemMessage:i.eChatSettingTone.FORMAL,options:{maxGptTokensForEachCall:p.SETTING_TOKEN_LENGTH.medium}},f=new n.ChatRepositoryInMemory;class v{constructor(){this.subscribeOnUpdateMessage=l.subscribeOnUpdateMessage.bind(l),this.subscribeOnUpdateSetting=l.subscribeOnUpdateSetting.bind(l),this.unSubscribeOnUpdateMessage=l.unSubscribeOnUpdateMessage.bind(l),this.unSubscribeOnUpdateSetting=l.unSubscribeOnUpdateSetting.bind(l),this.chatService=s.ChatService.init(g,o.api,f)}clearMessages(){return u(this,void 0,void 0,(function*(){const e=yield this.chatService.clearMessages();return h.notify(e),e}))}createMessageBot(e,t){const r=this.chatService.createMessageBot(e,t),s=this.chatService.getMessages();return h.notify(s),r}createMessageUser(e,t){const r=this.chatService.createMessageUser(e,t),s=this.chatService.getMessages();return h.notify(s),r}getLastMessages(e){return this.chatService.getLastMessages(e)}getMessages(){return this.chatService.getMessages()}getSettings(){return this.chatService.getSettings()}initMessages(e){return u(this,void 0,void 0,(function*(){try{yield this.chatService.initMessages(e);const t=this.chatService.getMessages();h.notify(t)}catch(e){console.error(e)}}))}initSetting(e){return u(this,void 0,void 0,(function*(){try{yield this.chatService.initSetting(e);const t=this.chatService.getSettings();d.notify(t)}catch(e){console.error(e)}}))}sendMessage(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return u(this,void 0,void 0,(function*(){const r=yield this.chatService.sendMessage(e,t);if(!r.isError){const e=this.chatService.getMessages();h.notify(e)}return r}))}setSettings(e){this.chatService.setSettings(e);const t=this.chatService.getSettings();d.notify(t)}}},"./src/infrastructure/adapters/index.ts":(e,t,r)=>{r.r(t),r.d(t,{AuthAdapter:()=>s.AuthAdapter,ChatAdapter:()=>i.ChatAdapter,UserAdapter:()=>n.UserAdapter});var s=r("./src/infrastructure/adapters/authAdapter.ts"),i=r("./src/infrastructure/adapters/chatAdapter.ts"),n=r("./src/infrastructure/adapters/userAdapter.ts")},"./src/infrastructure/adapters/userAdapter.ts":(e,t,r)=>{r.r(t),r.d(t,{UserAdapter:()=>h});var s=r("./src/services/userService/index.ts"),i=(r("./src/core/user.ts"),r("./src/lib/subject.ts")),n=r("./src/infrastructure/api.ts"),o=r("./src/infrastructure/observers/index.ts");const c=new i.Subject,a=new o.ObserverUserImpl(c),u={id:"",email:"",name:""};class h{constructor(){this.subscribeOnUpdateUser=a.subscribeOnUpdateUser.bind(a),this.unSubscribeOnUpdateUser=a.unSubscribeOnUpdateUser.bind(a),this.userService=s.UserService.init(u,n.api)}getInfo(){return e=this,t=void 0,s=function*(){return this.userService.getInfo()},new((r=void 0)||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}));var e,t,r,s}set(e){const t=this.userService.set(e);return t?(c.notify(t),t):(c.notify(null),null)}}},"./src/infrastructure/api.ts":(e,t,r)=>{r.r(t),r.d(t,{api:()=>n});var s=r("./src/infrastructure/httpClient/index.ts"),i=r("./src/infrastructure/httpURL/index.ts");const n={client:new s.HttpClient(fetch.bind(globalThis)),url:new i.HttpURL(i.urls)}},"./src/infrastructure/chatRepositoryInMemory.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatRepositoryInMemory:()=>i});var s=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))};class i{deleteMessages(){return s(this,void 0,void 0,(function*(){}))}deleteSetting(){return s(this,void 0,void 0,(function*(){}))}mergeSetting(e){return s(this,void 0,void 0,(function*(){return Promise.resolve(e)}))}readMessages(){return s(this,void 0,void 0,(function*(){return Promise.resolve(null)}))}readSetting(){return s(this,void 0,void 0,(function*(){return Promise.resolve(null)}))}writeMessages(e){return s(this,void 0,void 0,(function*(){return Promise.resolve(e)}))}writeSetting(e){return s(this,void 0,void 0,(function*(){return Promise.resolve(e)}))}}},"./src/infrastructure/crypto/cryptoChannel.ts":(e,t,r)=>{r.r(t),r.d(t,{CryptoChannel:()=>n}),r("./src/infrastructure/crypto/cryptoChannel.types.ts");var s=r("./src/lib/string.ts"),i=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))};class n{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"21749580627744043490293460885184921736187892537578287943095433020419112973523",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"64549560279114833959357227200374692973440838462517619633445557604010912723288";this.SharedKeyX=e,this.SharedKeyY=t,this.window=window}ApplySecurityCode(e){return i(this,void 0,void 0,(function*(){const t=e.padEnd(8,"_"),r=this.SharedKeyX+this.SharedKeyY,i=yield this.window.crypto.subtle.importKey("raw",(new TextEncoder).encode(r),{name:"PBKDF2"},!1,["deriveBits","deriveKey"]),n=yield this.window.crypto.subtle.importKey("raw",(new TextEncoder).encode(this.SharedKeyX),{name:"PBKDF2"},!1,["deriveBits","deriveKey"]);this.aesKey=yield this.window.crypto.subtle.deriveKey({name:"PBKDF2",iterations:1e3,hash:"SHA-1",salt:(new TextEncoder).encode(t)},i,{name:"AES-CBC",length:256},!0,["encrypt","decrypt"]);const o=yield this.window.crypto.subtle.deriveKey({name:"PBKDF2",iterations:1e3,hash:"SHA-1",salt:(new TextEncoder).encode((0,s.reverseString)(t))},n,{name:"AES-CBC",length:256},!0,["encrypt","decrypt"]),c=yield this.window.crypto.subtle.exportKey("raw",o);this.aesIV=c.slice(0,16)}))}DecryptMessage(e,t){return i(this,void 0,void 0,(function*(){const r=yield this.decryptAES(e,t);return JSON.parse(r)}))}EncryptMessage(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return i(this,void 0,void 0,(function*(){const r=JSON.stringify(e);return yield this.encryptAES(r,t)}))}DecryptObject(e){return i(this,void 0,void 0,(function*(){const t=yield this.decryptAES(e,!1);return JSON.parse(t)}))}EncryptObject(e){return i(this,void 0,void 0,(function*(){const t=JSON.stringify(e);return yield this.encryptAES(t,!1)}))}encryptAES(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return i(this,void 0,void 0,(function*(){if(!this.aesKey||!this.aesIV)return e;t||(e=Buffer.from(e,"utf-8").toString("base64"));const r=yield this.window.crypto.subtle.encrypt({name:"AES-CBC",iv:this.aesIV},this.aesKey,(new TextEncoder).encode(e));return Buffer.from(r).toString("base64")}))}decryptAES(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return i(this,void 0,void 0,(function*(){if(!this.aesKey||!this.aesIV)return e;const r=yield this.window.crypto.subtle.decrypt({name:"AES-CBC",iv:this.aesIV},this.aesKey,Buffer.from(e,"base64")).catch(console.error);if(!r)throw console.trace(),console.log(e),new Error("Decrypted Error");const s=Buffer.from(r).toString("utf8");return t?s:Buffer.from(s,"base64").toString("utf-8")}))}}},"./src/infrastructure/crypto/cryptoChannel.types.ts":(e,t,r)=>{r.r(t)},"./src/infrastructure/devices/audioInfo.ts":(e,t,r)=>{r.r(t),r.d(t,{AudioInfo:()=>s});class s{GetContext(e){return{samplerate:e.sampleRate}}GetDestination(e){const t=e.destination;return null!=t?{maxchannelscount:t.maxChannelCount,channelscount:t.channelCount,channelcountmode:t.channelCountMode,channelinterpretation:t.channelInterpretation,numberofinputs:t.numberOfInputs,numberofoutputs:t.numberOfOutputs}:{}}GetAnalyzer(e){const t=e.createAnalyser();return null!=t?{fftsize:t.fftSize,frequencybincount:t.frequencyBinCount,maxdecibels:t.maxDecibels,mindecibels:t.minDecibels,smoothingtimeconstant:t.smoothingTimeConstant,channelscount:t.channelCount,channelcountmode:t.channelCountMode,channelinterpretation:t.channelInterpretation,numberofinputs:t.numberOfInputs,numberofoutputs:t.numberOfOutputs}:{}}Get(){const e=new(window.AudioContext||window.webkitAudioContext);return null!=e?{context:this.GetContext(e),destination:this.GetDestination(e),analyser:this.GetAnalyzer(e)}:{}}}},"./src/infrastructure/devices/browserInfo.ts":(e,t,r)=>{r.r(t),r.d(t,{BrowserInfo:()=>s});class s{GetName(){const e=navigator.userAgent.toLowerCase();let t="unkown";return t=/mozilla/i.test(e)?"Mozilla":t,t=/ucbrowser/i.test(e)?"UCBrowser":t,t=/edg/i.test(e)?"Edge":t,t=/googlebot/i.test(e)?"GoogleBot":t,t=/chromium/i.test(e)?"Chromium":t,t=/firefox|fxios/i.test(e)&&!/seamonkey/i.test(e)?"Firefox":t,t=/; msie|trident/i.test(e)&&!/ucbrowser/i.test(e)?"IE":t,t=/chrome|crios/i.test(e)&&!/opr|opera|chromium|edg|ucbrowser|googlebot/i.test(e)?"Chrome":t,t=/safari/i.test(e)&&!/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(e)?"Safari":t,t=/opr|opera/i.test(e)?"Opera":t,t}GetVersion(){const e=navigator.userAgent.toLowerCase();switch(this.GetName()){case"UCBrowser":return this.GetVersion_(e,/(ucbrowser)\/([\d\.]+)/i);case"Edge":return this.GetVersion_(e,/(edge|edga|edgios|edg)\/([\d\.]+)/i);case"GoogleBot":return this.GetVersion_(e,/(googlebot)\/([\d\.]+)/i);case"Chromium":return this.GetVersion_(e,/(chromium)\/([\d\.]+)/i);case"Firefox":return this.GetVersion_(e,/(firefox|fxios)\/([\d\.]+)/i);case"Chrome":return this.GetVersion_(e,/(chrome|crios)\/([\d\.]+)/i);case"Safari":return this.GetVersion_(e,/(safari)\/([\d\.]+)/i);case"Opera":return this.GetVersion_(e,/(opera|opr)\/([\d\.]+)/i);case"IE":return this.GetVersion_(e,/(trident)\/([\d\.]+)/i);case"Mozilla":return this.GetVersion_(e,/(mozilla)\/([\d\.]+)/i)}return"unknown"}GetVersion_(e,t){return e.match(t)?e.match(t)[2]:""}Get(){return{name:this.GetName(),version:this.GetVersion()}}}},"./src/infrastructure/devices/cpuInfo.ts":(e,t,r)=>{r.r(t),r.d(t,{CpuInfo:()=>s});class s{GetArchitecture(){const e=navigator.userAgent.toLowerCase(),t=navigator.platform;if(e.includes("sun4"))return"SPARC";if(e.includes("aarch64")||e.includes("arm64")||e.includes("armv8"))return"arm64";if(e.includes("arm"))return"arm";if(e.includes("x64")||e.includes("wow64")||e.includes("x86_64")||e.includes("x86-64")||e.includes("amd64"))return"x64";if(e.includes("ia32"))return"x86";if(e.includes("ia64"))return"ia64";if(e.includes("i86pc")||e.includes("i386")||e.includes("i486")||e.includes("i586")||e.includes("i686"))return"x86";if(null!=t){if("macintel"==t)return"intel";if("macppc"==t)return"powerpc";if("mac68k"==t)return"68k";if(t.includes("arm"))return t.includes("armv8")?"arm64":"arm";if(t.includes("aarch64"))return"arm64"}return e.includes("windows")?"x86":e.includes("android")||e.includes("windows phone")||e.includes("iphone")||e.includes("ipad")||e.includes("ipod")?"arm":"unknown"}GetCores(){const e=navigator.hardwareConcurrency;return null!=e?e:0}Get(){return{architecture:this.GetArchitecture(),cores:this.GetCores()}}}},"./src/infrastructure/devices/deviceInfo.ts":(e,t,r)=>{r.r(t),r.d(t,{DeviceInfo:()=>u});var s=r("./src/infrastructure/devices/audioInfo.ts"),i=r("./src/infrastructure/devices/browserInfo.ts"),n=r("./src/infrastructure/devices/cpuInfo.ts"),o=r("./src/infrastructure/devices/osInfo.ts"),c=r("./src/infrastructure/devices/screenInfo.ts"),a=r("./src/infrastructure/devices/webglInfo.ts");class u{static GetCpu(){return this.cpu||(this.cpu=new n.CpuInfo),this.cpu}static GetOs(){return this.os||(this.os=new o.OsInfo),this.os}static GetScreen(){return this.screen||(this.screen=new c.ScreenInfo),this.screen}static GetAudio(){return this.audio||(this.audio=new s.AudioInfo),this.audio}static GetWebGL(){return this.webgl||(this.webgl=new a.WebGLInfo),this.webgl}static GetBrowser(){return this.browser||(this.browser=new i.BrowserInfo),this.browser}static GetDesc(){const e={cpu:this.GetCpu().Get(),os:this.GetOs().GetFull(),screen:this.GetScreen().GetFull(),audio:this.GetAudio().Get(),webgl:this.GetWebGL().Get(),browser:this.GetBrowser().Get(),agent:navigator.userAgent};return JSON.stringify(e)}static GetHash(){return e=this,t=void 0,s=function*(){const e={cpu:this.GetCpu().Get(),os:this.GetOs().GetShort(),screen:this.GetScreen().GetShort(),audio:this.GetAudio().Get(),webgl:this.GetWebGL().Get()},t=yield window.crypto.subtle.digest("SHA-512",(new TextEncoder).encode(JSON.stringify(e)));return Buffer.from(t).toString("hex")},new((r=void 0)||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}));var e,t,r,s}}},"./src/infrastructure/devices/osInfo.ts":(e,t,r)=>{r.r(t),r.d(t,{OsInfo:()=>s});class s{TrimVersionZeros(e,t){const r=t+"0";for(;e.endsWith(r);)e=e.substr(0,e.length-r.length);return e}GetVersion(){const e=navigator.userAgent,t=["Windows Phone","Windows","Android","iPhone","iPad","iPod","Mac","Tablet OS","Linux Mint","Linux","Ubuntu","UNIX","Debian","OpenBSD","FreeBSD","Xubuntu","KaiOS","CentOS","Gentoo","Haiku","Kubuntu","SunOS","QNX","BeOS","OS/2","CrOS","Tizen","Red Hat","SuSE","Cygwin","Symbian","hpwOS","webOS","X11"];for(const s of t)if(e.includes(s)){var r;return"Windows"==s&&null!=(r=/Windows NT ([0-9\.]*)/.exec(e))?r[0]:"Android"==s&&null!=(r=/Android ([0-9\.]*)/.exec(e))?this.TrimVersionZeros(r[0],"."):"iPhone"!=s&&"iPad"!=s&&"iPod"!=s||null==(r=/OS ([0-9_]*)/.exec(e))?"Mac"==s&&null!=(r=/Mac OS X ([0-9_]*)/.exec(e))?null!=navigator.maxTouchPoints&&navigator.maxTouchPoints>2?"iOS "+this.TrimVersionZeros(r[1],"_"):"OS X "+this.TrimVersionZeros(r[1],"_"):s:"iOS "+this.TrimVersionZeros(r[1],"_")}return"unknown"}GetTimeZone(){return(new Date).getTimezoneOffset()}GetType(){const e=navigator.userAgent;return/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(e)?"Tablet":/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(e)?"Mobile":"Desktop"}GetDevice(){const e="function",t="model",r="type",s="vendor",i="console",n="mobile",o="tablet",c="smarttv",a="wearable",u="Amazon",h="Apple",d="ASUS",l="Google",p="Huawei",g="LG",f="Microsoft",v="Motorola",b="Samsung",w="Sony",y="Xiaomi",S="Zebra",m=function(e,t){return e=e.replace(/^\s+|\s+$/g,""),void 0===t?e:e.substring(0,255)},E=[[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[t,[s,b],[r,o]],[/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[t,[s,b],[r,n]],[/\((ip(?:hone|od)[\w ]*);/i],[t,[s,h],[r,n]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[t,[s,h],[r,o]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[t,[s,p],[r,o]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i],[t,[s,p],[r,n]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[t,/_/g," "],[s,y],[r,n]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[t,/_/g," "],[s,y],[r,o]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i],[t,[s,"OPPO"],[r,n]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[t,[s,"Vivo"],[r,n]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[t,[s,"Realme"],[r,n]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[t,[s,v],[r,n]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[t,[s,v],[r,o]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[t,[s,g],[r,o]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[t,[s,g],[r,n]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[t,[s,"Lenovo"],[r,o]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[t,/_/g," "],[s,"Nokia"],[r,n]],[/(pixel c)\b/i],[t,[s,l],[r,o]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[t,[s,l],[r,n]],[/droid.+ ([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[t,[s,w],[r,n]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[t,"Xperia Tablet"],[s,w],[r,o]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[t,[s,"OnePlus"],[r,n]],[/(alexa)webm/i,/(kf[a-z]{2}wi)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[t,[s,u],[r,o]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[t,/(.+)/g,"Fire Phone $1"],[s,u],[r,n]],[/(playbook);[-\w\),; ]+(rim)/i],[t,s,[r,o]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[t,[s,"BlackBerry"],[r,n]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[t,[s,d],[r,o]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[t,[s,d],[r,n]],[/(nexus 9)/i],[t,[s,"HTC"],[r,o]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i],[s,[t,/_/g," "],[r,n]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[t,[s,"Acer"],[r,o]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[t,[s,"Meizu"],[r,n]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[t,[s,"Sharp"],[r,n]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[s,t,[r,n]],[/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[s,t,[r,o]],[/(surface duo)/i],[t,[s,f],[r,o]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[t,[s,"Fairphone"],[r,n]],[/(u304aa)/i],[t,[s,"AT&T"],[r,n]],[/\bsie-(\w*)/i],[t,[s,"Siemens"],[r,n]],[/\b(rct\w+) b/i],[t,[s,"RCA"],[r,o]],[/\b(venue[\d ]{2,7}) b/i],[t,[s,"Dell"],[r,o]],[/\b(q(?:mv|ta)\w+) b/i],[t,[s,"Verizon"],[r,o]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[t,[s,"Barnes & Noble"],[r,o]],[/\b(tm\d{3}\w+) b/i],[t,[s,"NuVision"],[r,o]],[/\b(k88) b/i],[t,[s,"ZTE"],[r,o]],[/\b(nx\d{3}j) b/i],[t,[s,"ZTE"],[r,n]],[/\b(gen\d{3}) b.+49h/i],[t,[s,"Swiss"],[r,n]],[/\b(zur\d{3}) b/i],[t,[s,"Swiss"],[r,o]],[/\b((zeki)?tb.*\b) b/i],[t,[s,"Zeki"],[r,o]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[s,"Dragon Touch"],t,[r,o]],[/\b(ns-?\w{0,9}) b/i],[t,[s,"Insignia"],[r,o]],[/\b((nxa|next)-?\w{0,9}) b/i],[t,[s,"NextBook"],[r,o]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[s,"Voice"],t,[r,n]],[/\b(lvtel\-)?(v1[12]) b/i],[[s,"LvTel"],t,[r,n]],[/\b(ph-1) /i],[t,[s,"Essential"],[r,n]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[t,[s,"Envizen"],[r,o]],[/\b(trio[-\w\. ]+) b/i],[t,[s,"MachSpeed"],[r,o]],[/\btu_(1491) b/i],[t,[s,"Rotor"],[r,o]],[/(shield[\w ]+) b/i],[t,[s,"Nvidia"],[r,o]],[/(sprint) (\w+)/i],[s,t,[r,n]],[/(kin\.[onetw]{3})/i],[[t,/\./g," "],[s,f],[r,n]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[t,[s,S],[r,o]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[t,[s,S],[r,n]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[s,t,[r,i]],[/droid.+; (shield) bui/i],[t,[s,"Nvidia"],[r,i]],[/(playstation [345portablevi]+)/i],[t,[s,w],[r,i]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[t,[s,f],[r,i]],[/smart-tv.+(samsung)/i],[s,[r,c]],[/hbbtv.+maple;(\d+)/i],[[t,/^/,"SmartTV"],[s,b],[r,c]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[s,g],[r,c]],[/(apple) ?tv/i],[s,[t,h+" TV"],[r,c]],[/crkey/i],[[t,"Chromecast"],[s,l],[r,c]],[/droid.+aft(\w)( bui|\))/i],[t,[s,u],[r,c]],[/\(dtv[\);].+(aquos)/i],[t,[s,"Sharp"],[r,c]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i],[[s,m],[t,m],[r,c]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[r,c]],[/((pebble))app/i],[s,t,[r,a]],[/droid.+; (glass) \d/i],[t,[s,l],[r,a]],[/droid.+; (wt63?0{2,3})\)/i],[t,[s,S],[r,a]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[s,[r,"embedded"]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[t,[r,n]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[t,[r,o]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[r,o]],[/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i],[[r,n]],[/(android[-\w\. ]{0,9});.+buil/i],[t,[s,"Generic"]]],x={};return x[s]="unknown",x[t]="unknown",x[r]="unknown",function(t,r){let s,i,n,o,c,a,u=0;for(;u<r.length&&!c;){const h=r[u],d=r[u+1];for(s=i=0;s<h.length&&!c;)if(c=h[s++].exec(t),c)for(n=0;n<d.length;n++)a=c[++i],o=d[n],"object"==typeof o&&o.length>0?2==o.length?typeof o[1]===e?o[0]=o[1].call(a):o[0]=o[1]:3==o.length?typeof o[1]!==e||o[1].exec&&o[1].test?o[0]=a?a.replace(o[1],o[2]):void 0:o[0]=a?o[1].call(a,o[2]):void 0:4==o.length&&(o[0]=a?o[3].call(a.replace(o[1],o[2])):void 0):o=a||void 0;u+=2}}.call(x,navigator.userAgent,E),{vendor:x[s],model:x[t]}}GetFull(){return{version:this.GetVersion(),timezone:this.GetTimeZone(),type:this.GetType(),device:this.GetDevice()}}GetShort(){return{version:this.GetVersion(),timezone:this.GetTimeZone()}}}},"./src/infrastructure/devices/screenInfo.ts":(e,t,r)=>{r.r(t),r.d(t,{ScreenInfo:()=>s});class s{GetDepth(){const e=window.screen.colorDepth;return null!=e?e:0}GetDevicePixelRatio(){const e=window.devicePixelRatio;return null!=e?e:1}GetWidth(){const e=window.screen.width;return null!=e?e:0}GetHeight(){const e=window.screen.height;return null!=e?e:0}GetSize(){return this.GetWidth()*this.GetHeight()}GetFull(){return{depth:this.GetDepth(),ratio:this.GetDevicePixelRatio(),width:this.GetWidth(),height:this.GetHeight(),size:this.GetSize()}}GetShort(){return{depth:this.GetDepth(),size:this.GetSize()}}}},"./src/infrastructure/devices/webglInfo.ts":(e,t,r)=>{r.r(t),r.d(t,{WebGLInfo:()=>s});class s{GetDepthBits(e){return null!=e?e:0}GetVendor(e){return null!=e?e.includes("Google Inc.")?"Google Inc.":e:"unknown"}GetRenderer(e){if(null!=e){if(e.includes("NVIDIA")){const t=/ANGLE \((NVIDIA, )?([ a-zA-Z0-9_\.]*)(,[ a-zA-Z0-9_\-\.]*)?\)/gm.exec(e);if(null!=t)return t[2]}return e}return"unknown"}Get(){const e=document.createElement("canvas");if(null!=e){const t=e.getContext("webgl")||e.getContext("experimental-webgl");if(null!=t){const e=t.getExtension("webgl_debug_renderer_info");return{depthbits:this.GetDepthBits(t.getParameter(t.DEPTH_BITS)),vendor:this.GetVendor(t.getParameter(e.UNMASKED_VENDOR_WEBGL)),renderer:this.GetRenderer(t.getParameter(e.UNMASKED_RENDERER_WEBGL))}}}return{}}}},"./src/infrastructure/httpClient/httpClient.ts":(e,t,r)=>{r.r(t),r.d(t,{HttpClient:()=>i}),r("./src/infrastructure/httpURL/index.ts"),r("./src/services/types/httpClient.ts");var s=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))};class i{constructor(e){this.headers={Accept:"application/json","Content-Type":"application/json"},this.setting={responseAs:"json",isCatchError:!1},this.requestInterceptor=e=>s(this,void 0,void 0,(function*(){})),this.responseInterceptor=(e,t)=>s(this,void 0,void 0,(function*(){})),this.request=e}get(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.setting;return s(this,void 0,void 0,(function*(){return yield this.sendRequestShort("GET",e,t,r)}))}post(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.setting;return s(this,void 0,void 0,(function*(){return yield this.sendRequestShort("POST",e,t,r)}))}put(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.setting;return s(this,void 0,void 0,(function*(){return yield this.sendRequestShort("PUT",e,t,r)}))}delete(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.setting;return s(this,void 0,void 0,(function*(){return yield this.sendRequestShort("DELETE",e,t,r)}))}sendGet(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.setting;return s(this,void 0,void 0,(function*(){return yield this.sendRequest("GET",e,t,r)}))}sendPost(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.setting;return s(this,void 0,void 0,(function*(){return yield this.sendRequest("POST",e,t,r)}))}sendPut(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.setting;return s(this,void 0,void 0,(function*(){return yield this.sendRequest("PUT",e,t,r)}))}sendDelete(e,t){let r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.setting;return s(this,void 0,void 0,(function*(){return yield this.sendRequest("DELETE",e,t,r)}))}setHeaders(e){this.headers=Object.assign(Object.assign({},this.headers),e)}setRequestInterceptor(e){this.requestInterceptor=e}setResponseInterceptor(e){this.responseInterceptor=e}sendRequest(e,t,r){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:this.setting;return s(this,void 0,void 0,(function*(){const s=Object.assign(Object.assign({},this.setting),{setting:i}),n=null!=r?r:{body:null},o=Object.assign({},n);o.body&&(o.body=JSON.stringify(o.body));const c=this.generateRequestOption(o);try{const r=Object.assign(Object.assign({},c),{credentials:"include"}),i={url:t,method:e,options:r};yield this.requestInterceptor(i);const n=yield this.request(i.url,Object.assign({method:i.method},i.options));if(yield this.responseInterceptor(n,null),n.ok&&200===n.status&&"error"===o.redirect)return yield this.generateResponseWithRedirect(n,s);if(!n.ok&&302===n.status)return null;if(n.ok)return yield this.generateResponse(n,s);this.makeNetworkError(n)}catch(e){return yield this.responseInterceptor(null,e),this.useCatchError(e,i)}}))}sendRequestShort(e,t,r){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:this.setting;return s(this,void 0,void 0,(function*(){const s=yield this.sendRequest(e,t,r,i);return s?s.data:null}))}generateRequestOption(e){const t=e.headers?e.headers:{};return Object.assign({headers:Object.assign(Object.assign({},this.headers),t)},e)}generateResponse(e,t){return s(this,void 0,void 0,(function*(){return{response:e,data:yield e[t.responseAs]()}}))}generateResponseWithRedirect(e,t){return s(this,void 0,void 0,(function*(){return{response:e,data:e.url}}))}useCatchError(e,t){if(console.error(e),t.isCatchError)return console.log(e),null;if(e instanceof Error&&e.message)throw new Error(e.message);throw new Error(e)}makeNetworkError(e){throw new Error(`Network Error\n STATUS: ${e.status},\n message: ${e.statusText},\n url: ${e.url},`)}}},"./src/infrastructure/httpClient/index.ts":(e,t,r)=>{r.r(t),r.d(t,{HttpClient:()=>s.HttpClient});var s=r("./src/infrastructure/httpClient/httpClient.ts")},"./src/infrastructure/httpURL/httpURL.ts":(e,t,r)=>{r.r(t),r.d(t,{HttpURL:()=>o,default:()=>c,urls:()=>n});var s=r("./src/lib/path.ts");const i="https://webapistage.r2copilot.ai",n={auth:{base:`${i}/api/v0.3/auth/login-hyperid`,check:`${i}/api/v0.3/auth/session`,logout:e=>{const t=`${i}/api/v0.3/auth/logout`;return e?`${t}?redirectUri=${e}`:t},callback:e=>{const t=new URL(`${i}/signin-hyperid`);for(const[r,s]of Object.entries(e))t.searchParams.set(r,s);return t.href}},chat:{message:`${i}/api/v0.3/ai/chat/completion`}};class o{constructor(e){this.urls=e}get(e){const t=(0,s.path)(this.urls)(e).result();if(!t)throw new Error(`URL with path ${e} not found`);if("function"==typeof t){for(var r=arguments.length,i=new Array(r>1?r-1:0),n=1;n<r;n++)i[n-1]=arguments[n];return t(...i)}return t}}const c=o},"./src/infrastructure/httpURL/index.ts":(e,t,r)=>{r.r(t),r.d(t,{HttpURL:()=>s.HttpURL,urls:()=>s.urls});var s=r("./src/infrastructure/httpURL/httpURL.ts")},"./src/infrastructure/observers/index.ts":(e,t,r)=>{r.r(t),r.d(t,{ObserverAuth:()=>o.ObserverAuth,ObserverAuthImpl:()=>n.ObserverAuthImpl,ObserverChat:()=>c.ObserverChat,ObserverChatImpl:()=>s.ObserverChatImpl,ObserverUser:()=>a.ObserverUser,ObserverUserImpl:()=>i.ObserverUserImpl});var s=r("./src/infrastructure/observers/observerChat.ts"),i=r("./src/infrastructure/observers/observerUser.ts"),n=r("./src/infrastructure/observers/observerAuth.ts"),o=r("./src/infrastructure/observers/observerAuth.types.ts"),c=r("./src/infrastructure/observers/observerChat.types.ts"),a=r("./src/infrastructure/observers/observerUser.types.ts")},"./src/infrastructure/observers/observerAuth.ts":(e,t,r)=>{r.r(t),r.d(t,{ObserverAuthImpl:()=>s});class s{constructor(e){this.subjectIsLoggedIn=e}subscribeOnUpdateLoggedIn(e){return this.subjectIsLoggedIn.subscribe(e),e}unSubscribeOnUpdateLoggedIn(e){return this.subjectIsLoggedIn.unsubscribe(e),e}}},"./src/infrastructure/observers/observerAuth.types.ts":(e,t,r)=>{r.r(t),r.d(t,{ObserverAuth:()=>s});class s{}},"./src/infrastructure/observers/observerChat.ts":(e,t,r)=>{r.r(t),r.d(t,{ObserverChatImpl:()=>s});class s{constructor(e,t){this.subjectMessage=e,this.subjectSetting=t}subscribeOnUpdateMessage(e){return this.subjectMessage.subscribe(e),e}subscribeOnUpdateSetting(e){return this.subjectSetting.subscribe(e),e}unSubscribeOnUpdateMessage(e){return this.subjectMessage.unsubscribe(e),e}unSubscribeOnUpdateSetting(e){return this.subjectSetting.unsubscribe(e),e}}},"./src/infrastructure/observers/observerChat.types.ts":(e,t,r)=>{r.r(t),r.d(t,{ObserverChat:()=>s});class s{}},"./src/infrastructure/observers/observerUser.ts":(e,t,r)=>{r.r(t),r.d(t,{ObserverUserImpl:()=>s});class s{constructor(e){this.subjectUser=e}subscribeOnUpdateUser(e){return this.subjectUser.subscribe(e),e}unSubscribeOnUpdateUser(e){return this.subjectUser.unsubscribe(e),e}}},"./src/infrastructure/observers/observerUser.types.ts":(e,t,r)=>{r.r(t),r.d(t,{ObserverUser:()=>s});class s{}},"./src/lib/crypto.ts":(e,t,r)=>{function s(){var e;if(null===(e=null===globalThis||void 0===globalThis?void 0:globalThis.crypto)||void 0===e?void 0:e.randomUUID)return globalThis.crypto.randomUUID();const t=new Array(36);for(let e=0;e<36;e++)t[e]=Math.floor(16*Math.random());return t[14]=4,t[19]=t[19]&=-5,t[19]=t[19]|=8,t[8]=t[13]=t[18]=t[23]="-",t.map((e=>e.toString(16))).join("")}r.r(t),r.d(t,{uuidV4:()=>s})},"./src/lib/index.ts":(e,t,r)=>{r.r(t),r.d(t,{Subject:()=>i.Subject,logger:()=>o.logger,path:()=>s.path,uuidV4:()=>n.uuidV4});var s=r("./src/lib/path.ts"),i=r("./src/lib/subject.ts"),n=r("./src/lib/crypto.ts"),o=r("./src/lib/logger.ts")},"./src/lib/logger.ts":(e,t,r)=>{r.r(t),r.d(t,{logger:()=>n});const s={get:function(e,t,r){const s=e[t];return"function"==typeof s?function(){for(var r=arguments.length,i=new Array(r),n=0;n<r;n++)i[n]=arguments[n];if("error"===t)return s(...i);if(e.printLogs){const e=`%c[${(new Date).toUTCString()}]`;return s(e,"background-color: #3174A6;color: #ffffff;font-weight: 600;border-radius: 2px;padding: 2px;font-size: 10px",...i)}}:s}},i=Object.create(globalThis.console);i.printLogs=!0;const n=new Proxy(i,s)},"./src/lib/path.ts":(e,t,r)=>{r.r(t),r.d(t,{path:()=>i});const s=e=>{const t=t=>s(e?t(e):null);return Object.assign(t,{map:t,chain:t=>t(e),result:()=>e})},i=e=>t=>s(t)((t=>t.split(".").reduce(((e,t)=>e[t]||null),e||{})))},"./src/lib/string.ts":(e,t,r)=>{function s(e){return e.split("").reverse().join("")}r.r(t),r.d(t,{reverseString:()=>s})},"./src/lib/subject.ts":(e,t,r)=>{r.r(t),r.d(t,{Subject:()=>s});class s{constructor(){this.observers=[]}subscribe(e){this.observers.push(e)}unsubscribe(e){this.observers=this.observers.filter((t=>e!==t))}notify(e){for(const t of this.observers)t.update(e)}}},"./src/services/authService/authConstans.ts":(e,t,r)=>{r.r(t),r.d(t,{default:()=>s});const s={AUTH_OPTIONS_INIT:{url:"http://0.0.0.0",redirectUri:"",clientId:""},AUTH_OPTIONS:{scope:"email",loginTypes:"web2+idp+"}}},"./src/services/authService/authService.ts":(e,t,r)=>{r.r(t),r.d(t,{AuthService:()=>n});var s=r("./src/services/authService/authConstans.ts"),i=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))};class n{constructor(e,t,r){return this.options=e,this.api=t,this.userService=r,this.queryByOptions={scope:"scope",flowMode:"flow_mode",loginTypes:"login_types_to_show",prompt:"prompt"},n.instance||(n.instance=this),this.options=e,n.instance}static init(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s.default.AUTH_OPTIONS_INIT;return new n(e,arguments.length>1?arguments[1]:void 0,arguments.length>2?arguments[2]:void 0)}getAuthLink(e){const t=new URL(this.api.url.get("auth.base"));t.searchParams.set("redirectUri",this.options.redirectUri),t.searchParams.set("intermediateRedirectUri",this.options.redirectUri);const r=this.optionsToQuery(e);for(const[e,s]of Object.entries(r))t.searchParams.set(e,s.toString());return t.href}setOptions(e){this.options=e}logout(e){return i(this,void 0,void 0,(function*(){const t=this.api.url.get("auth.logout",e);yield this.api.client.get(t,{headers:{Accept:"*/*","Content-Type":"*/*"}},{responseAs:"text",isCatchError:!0}),this.userService.set(null)}))}checkSession(){return i(this,void 0,void 0,(function*(){try{const e=this.api.url.get("auth.check"),t=yield this.api.client.get(e,{credentials:"include"});return!!t&&(this.userService.set(t),!0)}catch(e){return console.error(e),this.userService.set(null),!1}}))}processCallback(e){return i(this,void 0,void 0,(function*(){try{const t=this.api.url.get("auth.callback",e);yield this.api.client.get(t,{credentials:"include"})}catch(e){throw console.error(e),new Error("Process callback error")}}))}optionsToQuery(e){const t={};for(const[r,s]of Object.entries(e)){const e=this.queryByOptions[r];e?t[e]=s:(console.warn(`AuthService: Query for key ${r} not found`),t[r]=s)}return t}}},"./src/services/authService/authService.types.ts":(e,t,r)=>{r.r(t),r.d(t,{IAuthService:()=>s});class s{}},"./src/services/authService/index.ts":(e,t,r)=>{r.r(t),r.d(t,{AuthService:()=>s.AuthService});var s=r("./src/services/authService/authService.ts")},"./src/services/chatService/chatService.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatService:()=>a});var s=r("./src/core/chat.ts"),i=r("./src/core/chatSetting.ts"),n=r("./src/core/constants.ts"),o=(r("./src/services/chatService/chatService.types.ts"),r("./src/lib/crypto.ts")),c=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))};class a{constructor(e,t,r){this.chat=e,this.api=t,this.repository=r,this.initMessages(this.repository),this.initSetting(this.repository)}static init(e,t,r){const n=new i.ChatSetting(e),o=new s.Chat([],n);return new a(o,t,r)}getMessages(){return this.chat.getMessages().map((e=>e.get()))}getLastMessages(e){return this.chat.getLastMessages(e).map((e=>e.get()))}sendMessage(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return c(this,void 0,void 0,(function*(){const r=(0,o.uuidV4)(),s=Date.now(),i=this.createMessageUser(e,t).get(),n=this.getSettings();yield this.mergeMessagesHistory(n);const c=this.userMessageToUserBody(i,Object.assign({},n)),a=this.api.url.get("chat.message"),u=yield this.api.client.post(a,{body:c,headers:{"x-hs-request-id":r.toString()}});return u?(this.createMessageBot(u.content,u),{text:u.content,isError:!1,traceID:r,timestamp:s}):this.getEmptyResponse(r,s)}))}clearMessages(){return c(this,void 0,void 0,(function*(){this.chat=this.chat.clearMessage();const e=this.getMessages();return this.repository.writeMessages(e),e}))}createMessageUser(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this.chat=this.chat.createMessageUser(e);const r=this.getMessages(),s=this.chat.getLastMessage();return t&&this.repository.writeMessages(r),this.repository.writeMessages(r),s}createMessageBot(e,t){this.chat=this.chat.createMessageBot(e,t);const r=this.getMessages(),s=this.chat.getLastMessage();return this.repository.writeMessages(r),s}getSettings(){return this.chat.getSetting().get()}setSettings(e){const t=this.chat.getSetting().write(e);this.chat=this.chat.writeSetting(t),this.repository.writeSetting(e)}initMessages(e){return c(this,void 0,void 0,(function*(){this.repository=e;const t=yield this.repository.readMessages();if(t){const e=t.map((e=>this.chat.factory.createMessage(e)));this.chat=this.chat.writeMessages(e)}}))}initSetting(e){return c(this,void 0,void 0,(function*(){this.repository=e;const t=yield this.repository.readSetting();if(t){const e=this.chat.getSetting().write(t);this.chat=this.chat.writeSetting(e)}}))}userMessageToUserBody(e,t){const r=n.default.chat;return{userMessage:e.value,systemMessage:r.TONE_BASE+t.systemMessage,options:Object.assign({},t.options)}}mergeMessagesHistory(e){return c(this,void 0,void 0,(function*(){let t=null;if(n.MESSAGES_HISTORY_SIZE>0){const e=yield this.repository.readMessages();e&&(t=e.slice(-n.MESSAGES_HISTORY_SIZE).map((e=>({role:e.sender,content:e.value}))))}e.options?e.options.history={messages:t}:e.options={history:{messages:t}}}))}getEmptyResponse(e,t){return{text:"",isError:!0,traceID:e,timestamp:t}}}},"./src/services/chatService/chatService.types.ts":(e,t,r)=>{r.r(t),r.d(t,{IChatRepository:()=>s,IChatService:()=>i});class s{constructor(e,t){}}class i{}},"./src/services/chatService/index.ts":(e,t,r)=>{r.r(t),r.d(t,{ChatService:()=>s.ChatService});var s=r("./src/services/chatService/chatService.ts")},"./src/services/types/httpClient.ts":(e,t,r)=>{r.r(t),r.d(t,{default:()=>s});class s{constructor(e){}}},"./src/services/userService/index.ts":(e,t,r)=>{r.r(t),r.d(t,{UserService:()=>s.UserService});var s=r("./src/services/userService/userService.ts")},"./src/services/userService/userService.ts":(e,t,r)=>{r.r(t),r.d(t,{UserService:()=>n});var s=r("./src/core/user.ts"),i=(r("./src/services/userService/userService.types.ts"),function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))});class n{constructor(e,t){this.user=e,this.api=t}static init(e,t){const r=new s.User(e);return new n(r,t)}getInfo(){return i(this,void 0,void 0,(function*(){return this.user?this.user.get():null}))}set(e){return e?(this.user=new s.User(e),e):(this.user=null,null)}}},"./src/services/userService/userService.types.ts":(e,t,r)=>{r.r(t),r.d(t,{IUserService:()=>s});class s{}}},r={};function s(e){var i=r[e];if(void 0!==i)return i.exports;var n=r[e]={exports:{}};return t[e](n,n.exports,s),n.exports}s.d=(e,t)=>{for(var r in t)s.o(t,r)&&!s.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},s.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),s.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var i={};(()=>{s.r(i),s.d(i,{Application:()=>e.Application});var e=s("./src/application.ts")})();var n=i.Application;const o=window.Office;var c,a="CHAT.ERR-SUBS-NOT-FOUND",u="CHAT.ERR-SUBS-INACTIVE",h="CHAT.ERR-SUBS-EXPIRED",d="CHAT.ERR-SUBS-NO-USERS",l="CHAT.ERR-SUBS-NO-TOKENS",p="CHAT.ERR-TIMEOUT",g="CHAT.ERR-UNKNOWN",f="CHAT.ERR-MSG1",v="CHAT.ERR-MSG2",b="CHAT.ERR-MSG3",w=((c={})["CHAT.ERR-SESS-NOT-FOUND"]="To continue using R2 services, login or re-login is required.",c[a]="Oops! R2 couldn't find your subscription. Please make sure you signed in with the correct account.",c[u]="Uh-oh! It seems like your subscription isn't active at the moment. Please renew your subscription to continue accessing R2 services.",c[h]="Oh dear! Your subscription has expired. Please consider renewing it to regain access to R2 services.",c[d]="Looks like you've reached the maximum number of users allowed for your subscription. Consider upgrading your plan.",c[l]="Oops! You've used up all your subscription tokens. Get a new subscription for more tokens.",c[p]="R2 cannot generate a reply to your request as it has exceeded the processing time limit.",c[g]="Unknown error",c[f]="I am sorry, but I cannot provide you with the answer to this question. It is against my guidelines to help you respond to questions of sexuality, violence, hate, and self-harm. I encourage you to maintain a safe and respectful conversation environment. If you have other questions or need help with other topics, I will be happy to be of assistance.",c[v]="I am sorry, but I cannot respond to or comment on inappropriate topics, including topics that are sexual, violent, hateful, or self-harming. My goal is to help, educate, and have positive and respectful conversations. If you have other questions or need help with another topic, please feel free to ask. I'm happy to help.",c[b]="Oops! It seems our system is experiencing a high volume of traffic right now. Please take a moment and try again shortly. We appreciate your patience!",c),y=function(e){return w[e]},S=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))},m=function(e,t){var r,s,i,n,o={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return n={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(n[Symbol.iterator]=function(){return this}),n;function c(c){return function(a){return function(c){if(r)throw new TypeError("Generator is already executing.");for(;n&&(n=0,c[0]&&(o=0)),o;)try{if(r=1,s&&(i=2&c[0]?s.return:c[0]?s.throw||((i=s.return)&&i.call(s),0):s.next)&&!(i=i.call(s,c[1])).done)return i;switch(s=0,i&&(c=[2&c[0],i.value]),c[0]){case 0:case 1:i=c;break;case 4:return o.label++,{value:c[1],done:!1};case 5:o.label++,s=c[1],c=[0];continue;case 7:c=o.ops.pop(),o.trys.pop();continue;default:if(!((i=(i=o.trys).length>0&&i[i.length-1])||6!==c[0]&&2!==c[0])){o=0;continue}if(3===c[0]&&(!i||c[1]>i[0]&&c[1]<i[3])){o.label=c[1];break}if(6===c[0]&&o.label<i[1]){o.label=i[1],i=c;break}if(i&&o.label<i[2]){o.label=i[2],o.ops.push(c);break}i[2]&&o.ops.pop(),o.trys.pop();continue}c=t.call(e,o)}catch(e){c=[6,e],s=0}finally{r=i=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},E=function(e,t,r,s){return new(r||(r=Promise))((function(i,n){function o(e){try{a(s.next(e))}catch(e){n(e)}}function c(e){try{a(s.throw(e))}catch(e){n(e)}}function a(e){var t;e.done?i(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(o,c)}a((s=s.apply(e,t||[])).next())}))},x=function(e,t){var r,s,i,n,o={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return n={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(n[Symbol.iterator]=function(){return this}),n;function c(c){return function(a){return function(c){if(r)throw new TypeError("Generator is already executing.");for(;n&&(n=0,c[0]&&(o=0)),o;)try{if(r=1,s&&(i=2&c[0]?s.return:c[0]?s.throw||((i=s.return)&&i.call(s),0):s.next)&&!(i=i.call(s,c[1])).done)return i;switch(s=0,i&&(c=[2&c[0],i.value]),c[0]){case 0:case 1:i=c;break;case 4:return o.label++,{value:c[1],done:!1};case 5:o.label++,s=c[1],c=[0];continue;case 7:c=o.ops.pop(),o.trys.pop();continue;default:if(!((i=(i=o.trys).length>0&&i[i.length-1])||6!==c[0]&&2!==c[0])){o=0;continue}if(3===c[0]&&(!i||c[1]>i[0]&&c[1]<i[3])){o.label=c[1];break}if(6===c[0]&&o.label<i[1]){o.label=i[1],i=c;break}if(i&&o.label<i[2]){o.label=i[2],o.ops.push(c);break}i[2]&&o.ops.pop(),o.trys.pop();continue}c=t.call(e,o)}catch(e){c=[6,e],s=0}finally{r=i=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,a])}}},M={HEADER_NAME_DEVICE_HASH:"x-device-hash",HEADER_NAME_REQUEST_ID:"x-hs-request-id",STORAGE_NAME_SESSION_ID:"session_id"},A=(new n).lib,O=A.crypto.Channel,I=A.device.Info,C="https://app.r2copilot.ai";function T(t,r,s,i,n){return E(this,void 0,void 0,(function(){var c,a,u,h,d,l,p,f,v,b,S,m,E,A,T,R,k,N;return x(this,(function(x){switch(x.label){case 0:if(!t||0===String(t).length)throw new Error("Missing required arguments prompt");if("[object Object]"===t)throw new Error("Put your value in quotes");if(!(c=localStorage.getItem(M.STORAGE_NAME_SESSION_ID)))throw new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable,"Session didn't found,please login with R2 Copilot Add-in");return[4,I.GetHash()];case 1:return a=x.sent(),[4,_(c,a)];case 2:if(!(u=x.sent()))throw new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable,"Session key didn't found,please login with R2 Copilot Add-in");return h="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var t=16*Math.random()|0;return("x"==e?t:3&t|8).toString(16)})),[4,o.onReady()];case 3:return d=x.sent(),l=d.host,p=d.platform,f=e,[4,(v=new O).ApplySecurityCode(u)];case 4:if(x.sent(),(k={"Content-Type":"application/json"})[M.HEADER_NAME_REQUEST_ID]=h,k[M.HEADER_NAME_DEVICE_HASH]=a,b=k,S={message:t,office_host:l,office_platform:p,manifest_version:f},i&&(S.knowledge=i),n&&(S.slot=n),s&&(S.role_information=s),r){if(r<10||r>8e3)throw new Error("Invalid argument value length. Must be between 10 and 8000.");S.max_tokens=r}return N={},[4,v.EncryptObject(S)];case 5:return N.data=x.sent(),m=N,[4,G("".concat(C,"/api/send-request/").concat(c),m,b)];case 6:return E=x.sent(),A=w[g],E.isError?(T=y(E.text))?[2,U(T)]:[2,U(A)]:[4,v.DecryptObject(E.text)];case 7:return(R=x.sent()).is_image?[2,U(A)]:[2,R]}}))}))}function G(e,t,r){return E(this,void 0,void 0,(function(){var s,i,n,o;return x(this,(function(c){switch(c.label){case 0:return c.trys.push([0,3,,4]),[4,fetch(e,{method:"POST",headers:r,body:JSON.stringify(t)})];case 1:return[4,(s=c.sent()).json()];case 2:if(i=c.sent(),s.ok&&i.success)return[2,{text:i.data,isError:!1}];throw new Error(i.error_message);case 3:return n=c.sent(),o={text:"Unknown error",isError:!0},n instanceof Error?(o.text=n.message,[2,o]):[2,o];case 4:return[2]}}))}))}function _(e,t){return E(this,void 0,void 0,(function(){var r,s,i,n,o,c;return x(this,(function(a){switch(a.label){case 0:return r="".concat(C,"/api/check-session/").concat(e),[4,fetch(r,{method:"POST",headers:(c={},c[M.HEADER_NAME_DEVICE_HASH]=t,c)})];case 1:return[4,(s=a.sent()).json()];case 2:if(i=a.sent(),!s.ok)throw new Error("The server is currently unavailable, please try again later");if(!i.success){if(n=y(i.error_message))throw new Error(n);throw new Error(i.error_message)}return o=i.session.user_id,[2,"".concat(e,"_").concat(o)]}}))}))}function U(e){return{content:e,tokens:0,is_image:!1}}!function(e,t,r){var s,i,n,o,c,a,u,h,d=0,l=!1,p=!1,g=!0,f=!t&&0!==t&&"function"==typeof requestAnimationFrame;if("function"!=typeof e)throw new TypeError("Expected a function");function v(t){return S(this,void 0,void 0,(function(){var r,n;return m(this,(function(c){switch(c.label){case 0:return r=s,n=i,s=i=void 0,d=t,[4,e.apply(n,r)];case 1:return[2,o=c.sent()]}}))}))}function b(e,t){return f?("number"==typeof c&&cancelAnimationFrame(c),requestAnimationFrame(e)):setTimeout(e,t)}function w(e){return S(this,void 0,void 0,(function(){var r;return m(this,(function(s){switch(s.label){case 0:return d=e,c=b(E,t),l?[4,v(e)]:[3,2];case 1:return r=s.sent(),[3,3];case 2:r=o,s.label=3;case 3:return[2,r]}}))}))}function y(e){var r=e-a;return void 0===a||r>=t||r<0||p&&e-d>=n}function E(){var e=Date.now();if(y(e))return x(e);c=b(E,function(e){var r=e-d,s=t-(e-a);return p?Math.min(s,n-r):s}(e))}function x(e){return S(this,void 0,void 0,(function(){return m(this,(function(t){switch(t.label){case 0:return c=void 0,g&&s?[4,v(e)]:[3,2];case 1:return[2,t.sent()];case 2:return s=i=void 0,[2,o]}}))}))}function M(){for(var e=[],r=0;r<arguments.length;r++)e[r]=arguments[r];return S(this,void 0,void 0,(function(){var r,n;return m(this,(function(u){if(r=Date.now(),n=y(r),s=e,i=this,a=r,n){if(void 0===c)return[2,w(a)];if(p)return c=b(E,t),[2,v(a)]}return void 0===c&&(c=b(E,t)),[2,o]}))}))}t=+t||0,h=typeof(u=r),null==u||"object"!==h&&"function"!==h||(l=!!r.leading,n=(p="maxWait"in r)?Math.max(+r.maxWait||0,t):n,g="trailing"in r?!!r.trailing:g),M.cancel=function(){void 0!==c&&function(e){if(f)return cancelAnimationFrame(e);clearTimeout(e)}(c),d=0,s=a=i=c=void 0},M.flush=function(){return void 0===c?o:x(Date.now())},M.pending=function(){return void 0!==c}}((function(e,t,r,s,i){return E(void 0,void 0,void 0,(function(){return x(this,(function(n){return[2,T(e,t,r,s,i)]}))}))}),500,{leading:!1,trailing:!0}),CustomFunctions.associate("COPILOTR2",(function(e,t,r,s,i,n){return E(this,void 0,void 0,(function(){var o,c,a,u,h;return x(this,(function(d){switch(d.label){case 0:if(d.trys.push([0,2,,3]),!e||0==String(e).length)throw new Error("Missing required argument prompt");return c="".concat(e),t&&(a=function(e){var t="";if(Array.isArray(e)&&1===e.length){var r=e[0];if(Array.isArray(r)&&1===r.length){var s=r[0];t=Array.isArray(s)||"object"==typeof s||void 0===s?JSON.stringify(s):"string"==typeof s?s:"".concat(s)}else t=JSON.stringify(r)}else t=JSON.stringify(e);return"string"==typeof e?e:t}(t),console.log(a),a&&(c+="".concat(a))),[4,T(c,r,s,i,n)];case 1:return(u=d.sent())&&u.content?[2,u.content]:[2];case 2:return h=d.sent(),o="#ERROR: ".concat(h.message||JSON.stringify(h)),console.error(o),[3,3];case 3:return[2,o]}}))}))}))})();